// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { AppsAnalyticsApiGetOsaAvailabilityData, AppsAnalyticsApiGetOsaAvailabilityResponses, AppsAnalyticsApiGetOsaBrandingData, AppsAnalyticsApiGetOsaBrandingResponses, AppsAnalyticsApiGetOsaFilterOptionsData, AppsAnalyticsApiGetOsaFilterOptionsResponses, AppsAnalyticsApiGetOsaOverviewData, AppsAnalyticsApiGetOsaOverviewResponses, AppsAnalyticsApiGetOsaProductData, AppsAnalyticsApiGetOsaProductResponses, AppsAnalyticsApiGetOsaStoreData, AppsAnalyticsApiGetOsaStoreDayData, AppsAnalyticsApiGetOsaStoreDayResponses, AppsAnalyticsApiGetOsaStoreProductDaysData, AppsAnalyticsApiGetOsaStoreProductDaysResponses, AppsAnalyticsApiGetOsaStoreResponses, AppsAnalyticsApiGetOsaStoresData, AppsAnalyticsApiGetOsaStoresResponses, AppsAnalyticsApiGetProductData, AppsAnalyticsApiGetProductResponses, AppsAnalyticsApiGetStoreDisplaysData, AppsAnalyticsApiGetStoreDisplaysResponses, AppsAnalyticsApiListCompanyStoreGroupsData, AppsAnalyticsApiListCompanyStoreGroupsResponses, AppsAnalyticsApiListDisplaysData, AppsAnalyticsApiListDisplaysResponses, AppsAnalyticsApiListProductImagesData, AppsAnalyticsApiListProductImagesResponses, AppsAnalyticsApiListTrackedProductsData, AppsAnalyticsApiListTrackedProductsResponses, AppsAuditsApiBatchGetAuditsData, AppsAuditsApiBatchGetAuditsResponses, AppsAuditsApiCreateFakeAuditData, AppsAuditsApiCreateFakeAuditResponses, AppsAuditsApiCreateFileUploadUrlData, AppsAuditsApiCreateFileUploadUrlResponses, AppsAuditsApiCreateVideoUploadUrlData, AppsAuditsApiCreateVideoUploadUrlResponses, AppsAuditsApiEndAuditData, AppsAuditsApiEndAuditResponses, AppsAuditsApiInternalAuditExportData, AppsAuditsApiInternalAuditExportResponses, AppsAuditsApiInternalAuditFilterOptionsData, AppsAuditsApiInternalAuditFilterOptionsResponses, AppsAuditsApiInternalAuditListData, AppsAuditsApiInternalAuditListResponses, AppsAuditsApiInternalAuditVideosData, AppsAuditsApiInternalAuditVideosResponses, AppsAuditsApiListAuditsData, AppsAuditsApiListAuditsResponses, AppsAuditsApiStartAuditData, AppsAuditsApiStartAuditResponses, AppsBrandsApiListBrandsData, AppsBrandsApiListBrandsResponses, AppsClassifierEvaluationApiGetRunData, AppsClassifierEvaluationApiGetRunResponses, AppsClassifierEvaluationApiImportRunData, AppsClassifierEvaluationApiImportRunResponses, AppsClassifierEvaluationApiListProductDetectionEvaluationsData, AppsClassifierEvaluationApiListProductDetectionEvaluationsResponses, AppsClassifierEvaluationApiListProductTrackEvaluationsData, AppsClassifierEvaluationApiListProductTrackEvaluationsResponses, AppsClassifierEvaluationApiListRunProductsData, AppsClassifierEvaluationApiListRunProductsResponses, AppsClassifierEvaluationApiListRunsData, AppsClassifierEvaluationApiListRunsResponses, AppsCompaniesApiListCompaniesData, AppsCompaniesApiListCompaniesResponses, AppsDataCollectionApiListDataCollectionUploadFilesData, AppsDataCollectionApiListDataCollectionUploadFilesResponses, AppsDataCollectionApiListDataCollectionUploadsData, AppsDataCollectionApiListDataCollectionUploadsResponses, AppsDemosApiGetSignedUrlsData, AppsDemosApiGetSignedUrlsResponses, AppsDevicesApiBatteryLowNotificationData, AppsDevicesApiBatteryLowNotificationResponses, AppsDevicesApiGetDeviceData, AppsDevicesApiGetDeviceResponses, AppsDevicesApiRefreshCredentialData, AppsDevicesApiRefreshCredentialResponses, AppsDevicesApiRegisterDeviceData, AppsDevicesApiRegisterDeviceResponses, AppsDevicesApiReportFirmwareData, AppsDevicesApiReportFirmwareResponses, AppsDevicesApiRequestTailscaleRefreshData, AppsDevicesApiRequestTailscaleRefreshResponses, AppsDevicesApiSyncTailscaleStatusData, AppsDevicesApiSyncTailscaleStatusResponses, AppsInStockReviewApiAddDetectionHardNegativeData, AppsInStockReviewApiAddDetectionHardNegativeResponses, AppsInStockReviewApiAddFrameHardNegativesData, AppsInStockReviewApiAddFrameHardNegativesResponses, AppsInStockReviewApiAssignDetectionDisplayData, AppsInStockReviewApiAssignDetectionDisplayResponses, AppsInStockReviewApiAutoApprovalSimulationData, AppsInStockReviewApiAutoApprovalSimulationResponses, AppsInStockReviewApiCompletePipelineJobData, AppsInStockReviewApiCompletePipelineJobResponses, AppsInStockReviewApiCreateDisplayData, AppsInStockReviewApiCreateDisplayInstanceData, AppsInStockReviewApiCreateDisplayInstanceResponses, AppsInStockReviewApiCreateDisplayResponses, AppsInStockReviewApiCreateLabelExportData, AppsInStockReviewApiCreateLabelExportResponses, AppsInStockReviewApiCreateManualDetectionData, AppsInStockReviewApiCreateManualDetectionResponses, AppsInStockReviewApiCreateOutOfStockEventData, AppsInStockReviewApiCreateOutOfStockEventResponses, AppsInStockReviewApiCreateVerificationJobData, AppsInStockReviewApiCreateVerificationJobResponses, AppsInStockReviewApiFailPipelineJobData, AppsInStockReviewApiFailPipelineJobResponses, AppsInStockReviewApiFinishDisplayReviewData, AppsInStockReviewApiFinishDisplayReviewResponses, AppsInStockReviewApiFinishQuickReviewData, AppsInStockReviewApiFinishQuickReviewResponses, AppsInStockReviewApiGetAggregatedProposalsData, AppsInStockReviewApiGetAggregatedProposalsResponses, AppsInStockReviewApiGetDetectionCropData, AppsInStockReviewApiGetDetectionCropResponses, AppsInStockReviewApiGetDetectionDetailData, AppsInStockReviewApiGetDetectionDetailResponses, AppsInStockReviewApiGetDetectionRecognizerDebugData, AppsInStockReviewApiGetDetectionRecognizerDebugResponses, AppsInStockReviewApiGetJobData, AppsInStockReviewApiGetJobResponses, AppsInStockReviewApiGetJobTimelineData, AppsInStockReviewApiGetJobTimelineResponses, AppsInStockReviewApiGetMetricsOverviewData, AppsInStockReviewApiGetMetricsOverviewResponses, AppsInStockReviewApiGetOutOfStockContextData, AppsInStockReviewApiGetOutOfStockContextResponses, AppsInStockReviewApiGetProductEvidenceData, AppsInStockReviewApiGetProductEvidenceResponses, AppsInStockReviewApiGetProductSetAccuracyData, AppsInStockReviewApiGetProductSetAccuracyResponses, AppsInStockReviewApiGetStreamFramesData, AppsInStockReviewApiGetStreamFramesResponses, AppsInStockReviewApiListCompletedJobsData, AppsInStockReviewApiListCompletedJobsResponses, AppsInStockReviewApiListDisplayBestFramesData, AppsInStockReviewApiListDisplayBestFramesResponses, AppsInStockReviewApiListJobProductsData, AppsInStockReviewApiListJobProductsResponses, AppsInStockReviewApiListNeedReviewJobsData, AppsInStockReviewApiListNeedReviewJobsResponses, AppsInStockReviewApiListQuickReviewData, AppsInStockReviewApiListQuickReviewResponses, AppsInStockReviewApiListStoreDisplayCandidatesData, AppsInStockReviewApiListStoreDisplayCandidatesResponses, AppsInStockReviewApiNextTaskData, AppsInStockReviewApiNextTaskResponses, AppsInStockReviewApiOpenJobTaskData, AppsInStockReviewApiOpenJobTaskResponses, AppsInStockReviewApiRegisterPipelineDisplayInstancesData, AppsInStockReviewApiRegisterPipelineDisplayInstancesResponses, AppsInStockReviewApiReleaseJobTaskData, AppsInStockReviewApiReleaseJobTaskResponses, AppsInStockReviewApiRemoveDetectionHardNegativeData, AppsInStockReviewApiRemoveDetectionHardNegativeResponses, AppsInStockReviewApiSavePipelineDetectionsData, AppsInStockReviewApiSavePipelineDetectionsResponses, AppsInStockReviewApiSetDetectionProductLabelsData, AppsInStockReviewApiSetDetectionProductLabelsResponses, AppsInStockReviewApiSetGroundTruthData, AppsInStockReviewApiSetGroundTruthResponses, AppsInStockReviewApiSetJobResultData, AppsInStockReviewApiSetJobResultResponses, AppsInStockReviewApiSetQualityControlData, AppsInStockReviewApiSetQualityControlResponses, AppsInStockReviewApiSubmitJobTaskData, AppsInStockReviewApiSubmitJobTaskResponses, AppsPetrolReviewClientApiGetAuditReviewData, AppsPetrolReviewClientApiGetAuditReviewResponses, AppsPetrolReviewClientApiGetResultsData, AppsPetrolReviewClientApiGetResultsResponses, AppsPetrolReviewClientApiListAuditsData, AppsPetrolReviewClientApiListAuditsResponses, AppsPetrolReviewClientApiListStoreGroupsData, AppsPetrolReviewClientApiListStoreGroupsResponses, AppsPetrolReviewInternalApiGetAuditVideosData, AppsPetrolReviewInternalApiGetAuditVideosResponses, AppsPetrolReviewInternalApiGetMetricsData, AppsPetrolReviewInternalApiGetMetricsResponses, AppsPetrolReviewInternalApiTriggerReviewData, AppsPetrolReviewInternalApiTriggerReviewResponses, AppsPetrolReviewInternalQuestionSetsActivateQuestionSetData, AppsPetrolReviewInternalQuestionSetsActivateQuestionSetResponses, AppsPetrolReviewInternalQuestionSetsCreateAssetTypeData, AppsPetrolReviewInternalQuestionSetsCreateAssetTypeResponses, AppsPetrolReviewInternalQuestionSetsDeactivateQuestionSetData, AppsPetrolReviewInternalQuestionSetsDeactivateQuestionSetResponses, AppsPetrolReviewInternalQuestionSetsDeleteAssetTypeData, AppsPetrolReviewInternalQuestionSetsDeleteAssetTypeResponses, AppsPetrolReviewInternalQuestionSetsListAssetTypesData, AppsPetrolReviewInternalQuestionSetsListAssetTypesResponses, AppsPetrolReviewInternalQuestionSetsListQuestionSetsData, AppsPetrolReviewInternalQuestionSetsListQuestionSetsResponses, AppsPetrolReviewInternalQuestionSetsUpdateAssetTypeData, AppsPetrolReviewInternalQuestionSetsUpdateAssetTypeResponses, AppsPetrolReviewInternalQuestionSetsUploadQuestionSetData, AppsPetrolReviewInternalQuestionSetsUploadQuestionSetResponses, AppsPetrolReviewInternalSandboxCloneIntoSandboxData, AppsPetrolReviewInternalSandboxCloneIntoSandboxResponses, AppsPetrolReviewInternalSandboxDeleteSandboxAuditData, AppsPetrolReviewInternalSandboxDeleteSandboxAuditResponses, AppsPetrolReviewPipelineApiGetReviewRubricData, AppsPetrolReviewPipelineApiGetReviewRubricResponses, AppsPetrolReviewPipelineApiPostReviewResultData, AppsPetrolReviewPipelineApiPostReviewResultResponses, AppsPetrolReviewReviewApiCompleteReviewData, AppsPetrolReviewReviewApiCompleteReviewResponses, AppsPetrolReviewReviewApiDeletePumpFramesData, AppsPetrolReviewReviewApiDeletePumpFramesResponses, AppsPetrolReviewReviewApiGetAuditResultData, AppsPetrolReviewReviewApiGetAuditResultResponses, AppsPetrolReviewReviewApiGetAuditTasksData, AppsPetrolReviewReviewApiGetAuditTasksResponses, AppsPetrolReviewReviewApiListPetrolReviewsData, AppsPetrolReviewReviewApiListPetrolReviewsResponses, AppsPetrolReviewReviewApiPublishReviewData, AppsPetrolReviewReviewApiPublishReviewResponses, AppsPetrolReviewReviewApiReopenReviewData, AppsPetrolReviewReviewApiReopenReviewResponses, AppsPetrolReviewReviewApiReviewPumpCheckData, AppsPetrolReviewReviewApiReviewPumpCheckResponses, AppsPetrolReviewReviewApiReviewTaskData, AppsPetrolReviewReviewApiReviewTaskResponses, AppsPetrolReviewReviewApiSavePumpFramesData, AppsPetrolReviewReviewApiSavePumpFramesResponses, AppsPetrolReviewReviewApiUpdatePumpCountData, AppsPetrolReviewReviewApiUpdatePumpCountResponses, AppsPetrolReviewReviewFramesGetAuditFramesData, AppsPetrolReviewReviewFramesGetAuditFramesResponses, AppsPetrolReviewReviewSearchSearchAuditFramesData, AppsPetrolReviewReviewSearchSearchAuditFramesResponses, AppsPetrolReviewSharedApiGetQuestionSetData, AppsPetrolReviewSharedApiGetQuestionSetResponses, AppsPetrolReviewSharedApiUpdateQuestionSetData, AppsPetrolReviewSharedApiUpdateQuestionSetResponses, AppsProductRecognizerApiAddProductImageData, AppsProductRecognizerApiAddProductImageResponses, AppsProductRecognizerApiBatchCreateProductsData, AppsProductRecognizerApiBatchCreateProductsResponses, AppsProductRecognizerApiBatchGetProductsData, AppsProductRecognizerApiBatchGetProductsResponses, AppsProductRecognizerApiCreateIndexData, AppsProductRecognizerApiCreateIndexResponses, AppsProductRecognizerApiCreateProductSetData, AppsProductRecognizerApiCreateProductSetResponses, AppsProductRecognizerApiDeleteProductImageData, AppsProductRecognizerApiDeleteProductImageResponses, AppsProductRecognizerApiDeleteProductSetData, AppsProductRecognizerApiDeleteProductSetResponses, AppsProductRecognizerApiGetIndexData, AppsProductRecognizerApiGetIndexResponses, AppsProductRecognizerApiGetProductData, AppsProductRecognizerApiGetProductImagesData, AppsProductRecognizerApiGetProductImagesResponses, AppsProductRecognizerApiGetProductResponses, AppsProductRecognizerApiGetProductSetData, AppsProductRecognizerApiGetProductSetResponses, AppsProductRecognizerApiListIndicesData, AppsProductRecognizerApiListIndicesResponses, AppsProductRecognizerApiListProductsData, AppsProductRecognizerApiListProductSetsData, AppsProductRecognizerApiListProductSetsResponses, AppsProductRecognizerApiListProductsResponses, AppsProductRecognizerApiQueryData, AppsProductRecognizerApiQueryResponses, AppsProductRecognizerApiRebuildIndexData, AppsProductRecognizerApiRebuildIndexResponses, AppsProductRecognizerApiSetPrimaryProductImageData, AppsProductRecognizerApiSetPrimaryProductImageResponses, AppsProductRecognizerApiUpdateProductSetData, AppsProductRecognizerApiUpdateProductSetResponses, AppsProductRecognizerApiUploadProductImageData, AppsProductRecognizerApiUploadProductImageResponses, AppsProductTrackLabelingApiGetTrackingJobData, AppsProductTrackLabelingApiGetTrackingJobResponses, AppsProductTrackLabelingApiGetTrackingJobResultsData, AppsProductTrackLabelingApiGetTrackingJobResultsResponses, AppsProductTrackLabelingApiProbeSourceData, AppsProductTrackLabelingApiProbeSourceResponses, AppsProductTrackLabelingApiTriggerTrackingData, AppsProductTrackLabelingApiTriggerTrackingResponses, AppsProductTrackLabelingLabelerApiDisputeTaskData, AppsProductTrackLabelingLabelerApiDisputeTaskResponses, AppsProductTrackLabelingLabelerApiListProductSetsData, AppsProductTrackLabelingLabelerApiListProductSetsResponses, AppsProductTrackLabelingLabelerApiListTasksData, AppsProductTrackLabelingLabelerApiListTasksResponses, AppsProductTrackLabelingLabelerApiNextTaskData, AppsProductTrackLabelingLabelerApiNextTaskResponses, AppsProductTrackLabelingLabelerApiOpenTaskData, AppsProductTrackLabelingLabelerApiOpenTaskResponses, AppsProductTrackLabelingLabelerApiProductImagesData, AppsProductTrackLabelingLabelerApiProductImagesResponses, AppsProductTrackLabelingLabelerApiReleaseTaskData, AppsProductTrackLabelingLabelerApiReleaseTaskResponses, AppsProductTrackLabelingLabelerApiSearchProductsData, AppsProductTrackLabelingLabelerApiSearchProductsResponses, AppsProductTrackLabelingLabelerApiSubmitTaskData, AppsProductTrackLabelingLabelerApiSubmitTaskResponses, AppsProductTrackLabelingLabelExplorerApiCreateLabelExportData, AppsProductTrackLabelingLabelExplorerApiCreateLabelExportResponses, AppsProductTrackLabelingLabelExplorerApiDeleteHardNegativeData, AppsProductTrackLabelingLabelExplorerApiDeleteHardNegativeResponses, AppsProductTrackLabelingLabelExplorerApiDeleteInStockReviewLabelData, AppsProductTrackLabelingLabelExplorerApiDeleteInStockReviewLabelResponses, AppsProductTrackLabelingLabelExplorerApiGetOverviewData, AppsProductTrackLabelingLabelExplorerApiGetOverviewResponses, AppsProductTrackLabelingLabelExplorerApiGetProductTrackLabelsData, AppsProductTrackLabelingLabelExplorerApiGetProductTrackLabelsResponses, AppsProductTrackLabelingLabelExplorerApiGetTrackDetailData, AppsProductTrackLabelingLabelExplorerApiGetTrackDetailResponses, AppsProductTrackLabelingLabelExplorerApiListHardNegativesData, AppsProductTrackLabelingLabelExplorerApiListHardNegativesResponses, AppsProductTrackLabelingLabelExplorerApiListInStockReviewLabelersData, AppsProductTrackLabelingLabelExplorerApiListInStockReviewLabelersResponses, AppsProductTrackLabelingLabelExplorerApiListInStockReviewLabelsData, AppsProductTrackLabelingLabelExplorerApiListInStockReviewLabelsResponses, AppsProductTrackLabelingLabelExplorerApiListProductsData, AppsProductTrackLabelingLabelExplorerApiListProductSetsData, AppsProductTrackLabelingLabelExplorerApiListProductSetsResponses, AppsProductTrackLabelingLabelExplorerApiListProductsResponses, AppsProductTrackLabelingLabelExplorerApiReassignTrackProductData, AppsProductTrackLabelingLabelExplorerApiReassignTrackProductResponses, AppsProductTrackLabelingLabelExplorerApiRemoveTrackProductData, AppsProductTrackLabelingLabelExplorerApiRemoveTrackProductResponses, AppsProductTrackLabelingLabelExplorerApiSetInStockReviewLabelTrustData, AppsProductTrackLabelingLabelExplorerApiSetInStockReviewLabelTrustResponses, AppsProductTrackLabelingLabelQualityStaffReviewApiAcceptAnswerData, AppsProductTrackLabelingLabelQualityStaffReviewApiAcceptAnswerResponses, AppsProductTrackLabelingLabelQualityStaffReviewApiAcceptWaitingAnswerData, AppsProductTrackLabelingLabelQualityStaffReviewApiAcceptWaitingAnswerResponses, AppsProductTrackLabelingLabelQualityStaffReviewApiCorrectGoldTrackData, AppsProductTrackLabelingLabelQualityStaffReviewApiCorrectGoldTrackResponses, AppsProductTrackLabelingLabelQualityStaffReviewApiGetAnswerData, AppsProductTrackLabelingLabelQualityStaffReviewApiGetAnswerResponses, AppsProductTrackLabelingLabelQualityStaffReviewApiGetGoldTrackData, AppsProductTrackLabelingLabelQualityStaffReviewApiGetGoldTrackResponses, AppsProductTrackLabelingLabelQualityStaffReviewApiKeepLabelData, AppsProductTrackLabelingLabelQualityStaffReviewApiKeepLabelResponses, AppsProductTrackLabelingLabelQualityStaffReviewApiListAnswersData, AppsProductTrackLabelingLabelQualityStaffReviewApiListAnswersResponses, AppsProductTrackLabelingLabelQualityStaffReviewApiListGoldTracksData, AppsProductTrackLabelingLabelQualityStaffReviewApiListGoldTracksResponses, AppsProductTrackLabelingLabelQualityStaffReviewApiListLabelerStatsData, AppsProductTrackLabelingLabelQualityStaffReviewApiListLabelerStatsResponses, AppsProductTrackLabelingLabelQualityStaffReviewApiListWaitingAnswersData, AppsProductTrackLabelingLabelQualityStaffReviewApiListWaitingAnswersResponses, AppsProductTrackLabelingLabelQualityStaffReviewApiRejectDisputesData, AppsProductTrackLabelingLabelQualityStaffReviewApiRejectDisputesResponses, AppsProductTrackLabelingLabelQualityStaffReviewApiRelabelData, AppsProductTrackLabelingLabelQualityStaffReviewApiRelabelResponses, AppsProductTrackLabelingLabelQualityStaffReviewApiRelabelWaitingAnswerData, AppsProductTrackLabelingLabelQualityStaffReviewApiRelabelWaitingAnswerResponses, AppsProductTrackLabelingLabelQualityStaffReviewApiRetireGoldTrackData, AppsProductTrackLabelingLabelQualityStaffReviewApiRetireGoldTrackResponses, AppsStoresApiCreateStoreData, AppsStoresApiCreateStoreGroupData, AppsStoresApiCreateStoreGroupResponses, AppsStoresApiCreateStoreResponses, AppsStoresApiGetNearbyStoresAllData, AppsStoresApiGetNearbyStoresAllResponses, AppsStoresApiGetNearbyStoresData, AppsStoresApiGetNearbyStoresResponses, AppsStoresApiImportStoresData, AppsStoresApiImportStoresResponses, AppsStoresApiListAllStoreGroupsData, AppsStoresApiListAllStoreGroupsResponses, AppsStoresApiListAllStoresData, AppsStoresApiListAllStoresResponses, AppsTelemetryApiIngestTelemetryData, AppsTelemetryApiIngestTelemetryResponses, AppsTelemetryApiListDeviceLogsData, AppsTelemetryApiListDeviceLogsResponses, AppsUsersApiAcceptInvitationData, AppsUsersApiAcceptInvitationResponses, AppsUsersApiCreateInvitationData, AppsUsersApiCreateInvitationResponses, AppsUsersApiDeactivatePushTokenData, AppsUsersApiDeactivatePushTokenResponses, AppsUsersApiGetCurrentUserData, AppsUsersApiGetCurrentUserResponses, AppsUsersApiRegisterPushTokenData, AppsUsersApiRegisterPushTokenResponses, AppsUsersApiValidateInvitationData, AppsUsersApiValidateInvitationResponses, AppsVerificationTasksApiBatchClaimData, AppsVerificationTasksApiBatchClaimResponses, AppsVerificationTasksApiClaimVerificationTaskData, AppsVerificationTasksApiClaimVerificationTaskResponses, AppsVerificationTasksApiGetSignedUrlsData, AppsVerificationTasksApiGetSignedUrlsResponses, AppsVerificationTasksApiGetVerificationTaskData, AppsVerificationTasksApiGetVerificationTaskResponses, AppsVerificationTasksApiListVerificationTasksData, AppsVerificationTasksApiListVerificationTasksResponses, AppsVerificationTasksApiNextTaskData, AppsVerificationTasksApiNextTaskResponses, AppsVerificationTasksApiReleaseVerificationTaskData, AppsVerificationTasksApiReleaseVerificationTaskResponses, AppsVerificationTasksApiSubmitVerificationTaskData, AppsVerificationTasksApiSubmitVerificationTaskResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get Osa Overview
 *
 * Powers the OSA home page.
 */
export const appsAnalyticsApiGetOsaOverview = <ThrowOnError extends boolean = false>(options: Options<AppsAnalyticsApiGetOsaOverviewData, ThrowOnError>) => (options.client ?? client).get<AppsAnalyticsApiGetOsaOverviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/analytics/{company_slug}/osa/overview',
    ...options
});

/**
 * Get Osa Availability
 *
 * Powers the OSA availability page.
 */
export const appsAnalyticsApiGetOsaAvailability = <ThrowOnError extends boolean = false>(options: Options<AppsAnalyticsApiGetOsaAvailabilityData, ThrowOnError>) => (options.client ?? client).get<AppsAnalyticsApiGetOsaAvailabilityResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/analytics/{company_slug}/osa/availability',
    ...options
});

/**
 * Get Osa Stores
 *
 * Powers the OSA stores page.
 */
export const appsAnalyticsApiGetOsaStores = <ThrowOnError extends boolean = false>(options: Options<AppsAnalyticsApiGetOsaStoresData, ThrowOnError>) => (options.client ?? client).get<AppsAnalyticsApiGetOsaStoresResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/analytics/{company_slug}/osa/stores',
    ...options
});

/**
 * Get Osa Store
 *
 * Powers the OSA store detail page.
 */
export const appsAnalyticsApiGetOsaStore = <ThrowOnError extends boolean = false>(options: Options<AppsAnalyticsApiGetOsaStoreData, ThrowOnError>) => (options.client ?? client).get<AppsAnalyticsApiGetOsaStoreResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/analytics/{company_slug}/osa/stores/{store_id}',
    ...options
});

/**
 * Get Osa Store Day
 *
 * Powers the OSA store-day detail page.
 */
export const appsAnalyticsApiGetOsaStoreDay = <ThrowOnError extends boolean = false>(options: Options<AppsAnalyticsApiGetOsaStoreDayData, ThrowOnError>) => (options.client ?? client).get<AppsAnalyticsApiGetOsaStoreDayResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/analytics/{company_slug}/osa/stores/{store_id}/days/{local_day}',
    ...options
});

/**
 * Get Osa Store Product Days
 *
 * Powers the evidence viewer displaying the historical status of a product at a given store.
 */
export const appsAnalyticsApiGetOsaStoreProductDays = <ThrowOnError extends boolean = false>(options: Options<AppsAnalyticsApiGetOsaStoreProductDaysData, ThrowOnError>) => (options.client ?? client).get<AppsAnalyticsApiGetOsaStoreProductDaysResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/analytics/{company_slug}/osa/stores/{store_id}/products/{product_id}/days',
    ...options
});

/**
 * Get Osa Product
 *
 * Powers the OSA product detail page.
 */
export const appsAnalyticsApiGetOsaProduct = <ThrowOnError extends boolean = false>(options: Options<AppsAnalyticsApiGetOsaProductData, ThrowOnError>) => (options.client ?? client).get<AppsAnalyticsApiGetOsaProductResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/analytics/{company_slug}/osa/products/{product_id}',
    ...options
});

/**
 * List Displays
 *
 * List stores with reviewed display sightings in the requested period.
 */
export const appsAnalyticsApiListDisplays = <ThrowOnError extends boolean = false>(options: Options<AppsAnalyticsApiListDisplaysData, ThrowOnError>) => (options.client ?? client).get<AppsAnalyticsApiListDisplaysResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/analytics/{company_slug}/displays',
    ...options
});

/**
 * Get Store Displays
 *
 * Return one store's displays and their daily observation histories.
 */
export const appsAnalyticsApiGetStoreDisplays = <ThrowOnError extends boolean = false>(options: Options<AppsAnalyticsApiGetStoreDisplaysData, ThrowOnError>) => (options.client ?? client).get<AppsAnalyticsApiGetStoreDisplaysResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/analytics/{company_slug}/displays/stores/{store_id}',
    ...options
});

/**
 * Get Osa Filter Options
 *
 * The brands and categories the filters can offer, each narrowed by what is picked in the other.
 */
export const appsAnalyticsApiGetOsaFilterOptions = <ThrowOnError extends boolean = false>(options: Options<AppsAnalyticsApiGetOsaFilterOptionsData, ThrowOnError>) => (options.client ?? client).get<AppsAnalyticsApiGetOsaFilterOptionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/analytics/{company_slug}/osa/filter-options',
    ...options
});

/**
 * List Tracked Products
 *
 * Members of the company's tracked product set, with primary images.
 */
export const appsAnalyticsApiListTrackedProducts = <ThrowOnError extends boolean = false>(options: Options<AppsAnalyticsApiListTrackedProductsData, ThrowOnError>) => (options.client ?? client).get<AppsAnalyticsApiListTrackedProductsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/analytics/{company_slug}/product-set/products',
    ...options
});

/**
 * List Company Store Groups
 *
 * Store groups of one kind belonging to the company in the URL, with signed logos.
 */
export const appsAnalyticsApiListCompanyStoreGroups = <ThrowOnError extends boolean = false>(options: Options<AppsAnalyticsApiListCompanyStoreGroupsData, ThrowOnError>) => (options.client ?? client).get<AppsAnalyticsApiListCompanyStoreGroupsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/analytics/{company_slug}/store-groups',
    ...options
});

/**
 * Get Osa Branding
 *
 * The client company's logo plus its field-rep providers', for the dashboard header.
 */
export const appsAnalyticsApiGetOsaBranding = <ThrowOnError extends boolean = false>(options: Options<AppsAnalyticsApiGetOsaBrandingData, ThrowOnError>) => (options.client ?? client).get<AppsAnalyticsApiGetOsaBrandingResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/analytics/{company_slug}/branding',
    ...options
});

/**
 * Get Product
 *
 * Catalog detail for one product.
 */
export const appsAnalyticsApiGetProduct = <ThrowOnError extends boolean = false>(options: Options<AppsAnalyticsApiGetProductData, ThrowOnError>) => (options.client ?? client).get<AppsAnalyticsApiGetProductResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/analytics/{company_slug}/products/{product_id}',
    ...options
});

/**
 * List Product Images
 *
 * Catalog images for one product, each with a signed URL.
 */
export const appsAnalyticsApiListProductImages = <ThrowOnError extends boolean = false>(options: Options<AppsAnalyticsApiListProductImagesData, ThrowOnError>) => (options.client ?? client).get<AppsAnalyticsApiListProductImagesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/analytics/{company_slug}/products/{product_id}/images',
    ...options
});

/**
 * List Audits
 *
 * Returns a paginated list of audits for the current user.
 *
 * Only returns audits with PROCESSING, AWAITING_VERIFICATION, or COMPLETE status, ordered by created_at desc.
 */
export const appsAuditsApiListAudits = <ThrowOnError extends boolean = false>(options?: Options<AppsAuditsApiListAuditsData, ThrowOnError>) => (options?.client ?? client).get<AppsAuditsApiListAuditsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/audits/',
    ...options
});

/**
 * Batch Get Audits
 *
 * Returns audit details for the provided audit IDs.
 *
 * Only returns audits owned by the current user.
 */
export const appsAuditsApiBatchGetAudits = <ThrowOnError extends boolean = false>(options: Options<AppsAuditsApiBatchGetAuditsData, ThrowOnError>) => (options.client ?? client).post<AppsAuditsApiBatchGetAuditsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/audits/batch-get',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Audit
 *
 * Starts a new audit session for a device.
 */
export const appsAuditsApiStartAudit = <ThrowOnError extends boolean = false>(options: Options<AppsAuditsApiStartAuditData, ThrowOnError>) => (options.client ?? client).post<AppsAuditsApiStartAuditResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/audits/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Fake Audit
 *
 * Fabricates an audit from video files already in a GCS directory and runs it through the real CV pipeline.
 *
 * Replicates the real start → upload → end lifecycle: creates the Audit, copies each video from
 * `source_gcs_uri` into the canonical upload path (gs://{GCS_AUDIT_UPLOAD_BUCKET_NAME}/
 * {audit.id}/{pipeline_id}/{file_name}), creates a Video entity per file, and leaves the audit at
 * AWAITING_VIDEO_UPLOAD. It then writes an UPLOAD_COMPLETED file into the audit directory,
 * firing the real Eventarc → router → CV pipeline chain.
 *
 * The audit is attributed to the calling staff user. `pipeline_id` is optional: when omitted it is
 * resolved from the given company's PipelineAssignment for the store (same as start_audit); when set
 * it is used as-is.
 */
export const appsAuditsApiCreateFakeAudit = <ThrowOnError extends boolean = false>(options: Options<AppsAuditsApiCreateFakeAuditData, ThrowOnError>) => (options.client ?? client).post<AppsAuditsApiCreateFakeAuditResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/audits/fake',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Video Upload Url
 *
 * Creates a signed URL for uploading a 30 seconds video snippet to an existing audit.
 */
export const appsAuditsApiCreateVideoUploadUrl = <ThrowOnError extends boolean = false>(options: Options<AppsAuditsApiCreateVideoUploadUrlData, ThrowOnError>) => (options.client ?? client).post<AppsAuditsApiCreateVideoUploadUrlResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/audits/{audit_id}/videos/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create File Upload Url
 *
 * Creates a signed URL for uploading a generic file (logs, IMU data, etc.) to an existing audit.
 */
export const appsAuditsApiCreateFileUploadUrl = <ThrowOnError extends boolean = false>(options: Options<AppsAuditsApiCreateFileUploadUrlData, ThrowOnError>) => (options.client ?? client).post<AppsAuditsApiCreateFileUploadUrlResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/audits/{audit_id}/files/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Internal Audit List
 *
 * Returns a paginated list of audits for the internal tooling audit list.
 *
 * Scope:
 * - 'client': audits performed by non-staff users (the reps).
 * - 'me': audits performed by the current staff member.
 *
 * Includes all statuses.
 */
export const appsAuditsApiInternalAuditList = <ThrowOnError extends boolean = false>(options?: Options<AppsAuditsApiInternalAuditListData, ThrowOnError>) => (options?.client ?? client).get<AppsAuditsApiInternalAuditListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/audits/staff-list',
    ...options
});

/**
 * Internal Audit Filter Options
 *
 * Returns the available options for the internal audit list's filters.
 */
export const appsAuditsApiInternalAuditFilterOptions = <ThrowOnError extends boolean = false>(options?: Options<AppsAuditsApiInternalAuditFilterOptionsData, ThrowOnError>) => (options?.client ?? client).get<AppsAuditsApiInternalAuditFilterOptionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/audits/staff-list/filter-options',
    ...options
});

/**
 * Internal Audit Export
 *
 * Streams the internal audit list as a CSV of the entire filtered result set.
 *
 * Takes the same filters as the list. Returns a raw StreamingHttpResponse.
 */
export const appsAuditsApiInternalAuditExport = <ThrowOnError extends boolean = false>(options?: Options<AppsAuditsApiInternalAuditExportData, ThrowOnError>) => (options?.client ?? client).get<AppsAuditsApiInternalAuditExportResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/audits/staff-list/export',
    ...options
});

/**
 * Internal Audit Videos
 *
 * Returns signed download URLs for one audit's videos.
 */
export const appsAuditsApiInternalAuditVideos = <ThrowOnError extends boolean = false>(options: Options<AppsAuditsApiInternalAuditVideosData, ThrowOnError>) => (options.client ?? client).get<AppsAuditsApiInternalAuditVideosResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/audits/{audit_id}/videos',
    ...options
});

/**
 * End Audit
 *
 * Marks an audit session as completed (move the state to AWAITING_VIDEO_UPLOAD).
 */
export const appsAuditsApiEndAudit = <ThrowOnError extends boolean = false>(options: Options<AppsAuditsApiEndAuditData, ThrowOnError>) => (options.client ?? client).post<AppsAuditsApiEndAuditResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/audits/{audit_id}/end',
    ...options
});

/**
 * List Brands
 *
 * Returns all brands, ordered by name.
 */
export const appsBrandsApiListBrands = <ThrowOnError extends boolean = false>(options?: Options<AppsBrandsApiListBrandsData, ThrowOnError>) => (options?.client ?? client).get<AppsBrandsApiListBrandsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/brands/',
    ...options
});

/**
 * List Runs
 */
export const appsClassifierEvaluationApiListRuns = <ThrowOnError extends boolean = false>(options?: Options<AppsClassifierEvaluationApiListRunsData, ThrowOnError>) => (options?.client ?? client).get<AppsClassifierEvaluationApiListRunsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/classifier-evaluation/runs',
    ...options
});

/**
 * Import Run
 */
export const appsClassifierEvaluationApiImportRun = <ThrowOnError extends boolean = false>(options: Options<AppsClassifierEvaluationApiImportRunData, ThrowOnError>) => (options.client ?? client).post<AppsClassifierEvaluationApiImportRunResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/classifier-evaluation/runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Run
 */
export const appsClassifierEvaluationApiGetRun = <ThrowOnError extends boolean = false>(options: Options<AppsClassifierEvaluationApiGetRunData, ThrowOnError>) => (options.client ?? client).get<AppsClassifierEvaluationApiGetRunResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/classifier-evaluation/runs/{run_id}',
    ...options
});

/**
 * List Run Products
 *
 * Returns a per-product summary of this run's results.
 */
export const appsClassifierEvaluationApiListRunProducts = <ThrowOnError extends boolean = false>(options: Options<AppsClassifierEvaluationApiListRunProductsData, ThrowOnError>) => (options.client ?? client).get<AppsClassifierEvaluationApiListRunProductsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/classifier-evaluation/runs/{run_id}/products',
    ...options
});

/**
 * List Product Track Evaluations
 *
 * Returns the run's evaluations of one product's tracks, most confidently wrong first.
 */
export const appsClassifierEvaluationApiListProductTrackEvaluations = <ThrowOnError extends boolean = false>(options: Options<AppsClassifierEvaluationApiListProductTrackEvaluationsData, ThrowOnError>) => (options.client ?? client).get<AppsClassifierEvaluationApiListProductTrackEvaluationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/classifier-evaluation/runs/{run_id}/products/{product_id}/tracks',
    ...options
});

/**
 * List Product Detection Evaluations
 *
 * Returns the run's evaluations of one product's ISR crops, most confidently wrong first.
 */
export const appsClassifierEvaluationApiListProductDetectionEvaluations = <ThrowOnError extends boolean = false>(options: Options<AppsClassifierEvaluationApiListProductDetectionEvaluationsData, ThrowOnError>) => (options.client ?? client).get<AppsClassifierEvaluationApiListProductDetectionEvaluationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/classifier-evaluation/runs/{run_id}/products/{product_id}/detections',
    ...options
});

/**
 * List Companies
 *
 * Returns all companies ordered by name, for staff tooling (e.g. inviting users).
 */
export const appsCompaniesApiListCompanies = <ThrowOnError extends boolean = false>(options?: Options<AppsCompaniesApiListCompaniesData, ThrowOnError>) => (options?.client ?? client).get<AppsCompaniesApiListCompaniesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/companies/',
    ...options
});

/**
 * List Data Collection Uploads
 *
 * Lists data collection uploads from the GCS index.
 *
 * Passes the previous response's `cursor` as `since` to fetch only newer uploads.
 * All search/filter/sort happens client side.
 */
export const appsDataCollectionApiListDataCollectionUploads = <ThrowOnError extends boolean = false>(options?: Options<AppsDataCollectionApiListDataCollectionUploadsData, ThrowOnError>) => (options?.client ?? client).get<AppsDataCollectionApiListDataCollectionUploadsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/data-collection/',
    ...options
});

/**
 * List Data Collection Upload Files
 *
 * Returns signed download URLs for one data collection upload's decrypted videos.
 *
 * An empty list means the directory has expired under the bucket lifecycle. The client should drop
 * the entry from its local cache.
 */
export const appsDataCollectionApiListDataCollectionUploadFiles = <ThrowOnError extends boolean = false>(options: Options<AppsDataCollectionApiListDataCollectionUploadFilesData, ThrowOnError>) => (options.client ?? client).get<AppsDataCollectionApiListDataCollectionUploadFilesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/data-collection/{audit_id}/files',
    ...options
});

/**
 * Get Signed Urls
 *
 * Returns short lived signed GET URLs for demo media paths.
 *
 * The backend service account can read other sensitive buckets, therefore the bucket
 * name is server controlled via project settings, never taken from the client.
 */
export const appsDemosApiGetSignedUrls = <ThrowOnError extends boolean = false>(options: Options<AppsDemosApiGetSignedUrlsData, ThrowOnError>) => (options.client ?? client).post<AppsDemosApiGetSignedUrlsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/demos/signed-urls',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register Device
 */
export const appsDevicesApiRegisterDevice = <ThrowOnError extends boolean = false>(options: Options<AppsDevicesApiRegisterDeviceData, ThrowOnError>) => (options.client ?? client).post<AppsDevicesApiRegisterDeviceResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/devices/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh Credential
 */
export const appsDevicesApiRefreshCredential = <ThrowOnError extends boolean = false>(options: Options<AppsDevicesApiRefreshCredentialData, ThrowOnError>) => (options.client ?? client).post<AppsDevicesApiRefreshCredentialResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/devices/{serial_number}/credential',
    ...options
});

/**
 * Battery Low Notification
 */
export const appsDevicesApiBatteryLowNotification = <ThrowOnError extends boolean = false>(options?: Options<AppsDevicesApiBatteryLowNotificationData, ThrowOnError>) => (options?.client ?? client).post<AppsDevicesApiBatteryLowNotificationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/devices/notifications/battery-low',
    ...options
});

/**
 * Report Firmware
 *
 * Reports the firmware version recorded for a badge.
 */
export const appsDevicesApiReportFirmware = <ThrowOnError extends boolean = false>(options: Options<AppsDevicesApiReportFirmwareData, ThrowOnError>) => (options.client ?? client).put<AppsDevicesApiReportFirmwareResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/devices/{serial_number}/firmware',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Device
 *
 * Returns device detail for the internal tool.
 */
export const appsDevicesApiGetDevice = <ThrowOnError extends boolean = false>(options: Options<AppsDevicesApiGetDeviceData, ThrowOnError>) => (options.client ?? client).get<AppsDevicesApiGetDeviceResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/devices/{serial_number}',
    ...options
});

/**
 * Request Tailscale Refresh
 *
 * Flags a badge to receive a fresh Tailscale key on its next app connection.
 */
export const appsDevicesApiRequestTailscaleRefresh = <ThrowOnError extends boolean = false>(options: Options<AppsDevicesApiRequestTailscaleRefreshData, ThrowOnError>) => (options.client ?? client).post<AppsDevicesApiRequestTailscaleRefreshResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/devices/{serial_number}/tailscale/refresh',
    ...options
});

/**
 * Sync Tailscale Status
 *
 * Records the badge's Tailscale status, then mints a key if a refresh is still pending.
 */
export const appsDevicesApiSyncTailscaleStatus = <ThrowOnError extends boolean = false>(options: Options<AppsDevicesApiSyncTailscaleStatusData, ThrowOnError>) => (options.client ?? client).post<AppsDevicesApiSyncTailscaleStatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/devices/{serial_number}/tailscale/sync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Detection Hard Negative
 *
 * Un-marks the detection as a hard negative against the job's product_set. Idempotent.
 */
export const appsInStockReviewApiRemoveDetectionHardNegative = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiRemoveDetectionHardNegativeData, ThrowOnError>) => (options.client ?? client).delete<AppsInStockReviewApiRemoveDetectionHardNegativeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/detections/{detection_id}/hard-negative',
    ...options
});

/**
 * Add Detection Hard Negative
 *
 * Marks the detection as a hard negative against the job's product_set.
 *
 * Idempotent: a repeat call returns the existing row with 200; first creation returns 201.
 */
export const appsInStockReviewApiAddDetectionHardNegative = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiAddDetectionHardNegativeData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiAddDetectionHardNegativeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/detections/{detection_id}/hard-negative',
    ...options
});

/**
 * List Store Display Candidates
 *
 * Returns the store's known displays, to enable linking a reviewed display to one seen on an earlier visit.
 */
export const appsInStockReviewApiListStoreDisplayCandidates = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiListStoreDisplayCandidatesData, ThrowOnError>) => (options.client ?? client).get<AppsInStockReviewApiListStoreDisplayCandidatesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/display-review/store-displays',
    ...options
});

/**
 * Get Stream Frames
 *
 * Returns a window of one stream's sampled frames around a frame position.
 *
 * Pair it with `/jobs/{job_id}/timeline`, which sizes the whole timeline without transferring
 * any of it.
 */
export const appsInStockReviewApiGetStreamFrames = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiGetStreamFramesData, ThrowOnError>) => (options.client ?? client).get<AppsInStockReviewApiGetStreamFramesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/frames',
    ...options
});

/**
 * Get Job Timeline
 *
 * Returns both streams' whole sampled-frame timelines, with no frame pixels.
 *
 * `min_proposal_score` tunes which detections vote for their frame's category; it is a request
 * param because the viewer retunes it per job, and it leaves `detection_counts` untouched. When
 * omitted, it is the job's `min_category_sighting_score`.
 *
 * `min_display_detections` / `min_display_frames` are the same knob for `displays`: how many of
 * a frame's detections must clear `min_proposal_score` for that frame to count towards a
 * display, and over how many distinct frames it must hold up — pooled across both cameras.
 */
export const appsInStockReviewApiGetJobTimeline = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiGetJobTimelineData, ThrowOnError>) => (options.client ?? client).get<AppsInStockReviewApiGetJobTimelineResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/timeline',
    ...options
});

/**
 * Get Job
 *
 * Returns the current status of an in-stock verification job.
 */
export const appsInStockReviewApiGetJob = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiGetJobData, ThrowOnError>) => (options.client ?? client).get<AppsInStockReviewApiGetJobResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}',
    ...options
});

/**
 * List Need Review Jobs
 *
 * Lists InStockVerificationJobs currently in the review phase.
 */
export const appsInStockReviewApiListNeedReviewJobs = <ThrowOnError extends boolean = false>(options?: Options<AppsInStockReviewApiListNeedReviewJobsData, ThrowOnError>) => (options?.client ?? client).get<AppsInStockReviewApiListNeedReviewJobsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs-need-review',
    ...options
});

/**
 * List Quick Review
 *
 * Every product the pipeline proposed a recognition for, with its crops, in one response.
 *
 * Args:
 * crops: How many thumbnails to return per product. Each one costs the page a full frame
 * download, so the caller picks the trade between evidence and page weight.
 */
export const appsInStockReviewApiListQuickReview = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiListQuickReviewData, ThrowOnError>) => (options.client ?? client).get<AppsInStockReviewApiListQuickReviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/quick-review',
    ...options
});

/**
 * Finish Quick Review
 *
 * Ends the quick review: applies every decision, then hands the rest to part two.
 */
export const appsInStockReviewApiFinishQuickReview = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiFinishQuickReviewData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiFinishQuickReviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/quick-review/finish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Display
 */
export const appsInStockReviewApiCreateDisplay = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiCreateDisplayData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiCreateDisplayResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/displays',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Display Instance
 */
export const appsInStockReviewApiCreateDisplayInstance = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiCreateDisplayInstanceData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiCreateDisplayInstanceResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/displays/{display_id}/instances',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assign Detection Display
 *
 * Puts a quick-review crop's detection on one of the job's reviewed displays.
 */
export const appsInStockReviewApiAssignDetectionDisplay = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiAssignDetectionDisplayData, ThrowOnError>) => (options.client ?? client).put<AppsInStockReviewApiAssignDetectionDisplayResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/detections/{detection_id}/display',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Next Task
 *
 * Returns the next task for a specific InStockVerificationJob.
 *
 * If the user already has a task IN_REVIEW within this job, return that one. Otherwise claim the
 * next PENDING task in review order.
 */
export const appsInStockReviewApiNextTask = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiNextTaskData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiNextTaskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/next-task',
    ...options
});

/**
 * Open Job Task
 *
 * Opens a specific task within an InStockVerificationJob.
 *
 * Mirrors next_task but targets a caller-specified task_id. Terminal tasks are returned as-is so
 * the UI can display finalised work.
 */
export const appsInStockReviewApiOpenJobTask = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiOpenJobTaskData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiOpenJobTaskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/tasks/{task_id}/open',
    ...options
});

/**
 * Release Job Task
 *
 * Releases the caller's claim on a task; the generic release endpoint is staff-only.
 */
export const appsInStockReviewApiReleaseJobTask = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiReleaseJobTaskData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiReleaseJobTaskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/tasks/{task_id}/release',
    ...options
});

/**
 * Submit Job Task
 *
 * Submits a verification task that belongs to the given InStockVerificationJob.
 *
 * Behaves like /verification-tasks/{task_id}/submit but additionally flips the parent job to
 * REVIEW_COMPLETED once every child task has reached a terminal status.
 */
export const appsInStockReviewApiSubmitJobTask = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiSubmitJobTaskData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiSubmitJobTaskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/tasks/{task_id}/submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Out Of Stock Context
 *
 * Evidence for deciding whether a product really is out of stock in this audit.
 *
 * `past_sightings` is where this product sat in earlier audits of the same store;
 * `category_confirmations` is frames of *this* job where a same-category product was confirmed.
 * A caller walking a category already holds the latter and passes
 * `include_category_confirmations=false` to skip the join.
 */
export const appsInStockReviewApiGetOutOfStockContext = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiGetOutOfStockContextData, ThrowOnError>) => (options.client ?? client).get<AppsInStockReviewApiGetOutOfStockContextResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/tasks/{task_id}/out-of-stock-context',
    ...options
});

/**
 * Set Detection Product Labels
 *
 * Manually labels every detection as the same product.
 *
 * Always overwrites — manual labels supersede task-derived labels and are not
 * overwritten by subsequent VerificationTask submissions.
 *
 * Reviewer-facing: this is how an out-of-stock confirmation resolves a label conflict. The box
 * the reviewer picked is already labelled as another product, and claiming it for theirs is the
 * way past the 409 — so a reviewer who cannot reach this endpoint is simply stuck.
 */
export const appsInStockReviewApiSetDetectionProductLabels = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiSetDetectionProductLabelsData, ThrowOnError>) => (options.client ?? client).put<AppsInStockReviewApiSetDetectionProductLabelsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/product-labels',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Manual Detection
 *
 * Persists a box a reviewer drew, so it can be labeled like any detected one.
 */
export const appsInStockReviewApiCreateManualDetection = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiCreateManualDetectionData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiCreateManualDetectionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/manual-detections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Out Of Stock Event
 *
 * Creates an out of stock event: the product is missing, and it should have been here.
 *
 * Returns the event id the task submit then carries as its `out_of_stock_event_id` evidence link.
 */
export const appsInStockReviewApiCreateOutOfStockEvent = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiCreateOutOfStockEventData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiCreateOutOfStockEventResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/products/{product_id}/out-of-stock-event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Display Best Frames
 */
export const appsInStockReviewApiListDisplayBestFrames = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiListDisplayBestFramesData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiListDisplayBestFramesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/display-review/best-frames',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Finish Display Review
 */
export const appsInStockReviewApiFinishDisplayReview = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiFinishDisplayReviewData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiFinishDisplayReviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/display-review/finish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Aggregated Proposals
 *
 * Aggregates proposals across detections.
 */
export const appsInStockReviewApiGetAggregatedProposals = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiGetAggregatedProposalsData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiGetAggregatedProposalsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/detections/proposals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Detection Detail
 *
 * Returns one detection's full ranked proposals — what the frontend renders on box click.
 */
export const appsInStockReviewApiGetDetectionDetail = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiGetDetectionDetailData, ThrowOnError>) => (options.client ?? client).get<AppsInStockReviewApiGetDetectionDetailResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/detections/{detection_id}',
    ...options
});

/**
 * Get Detection Crop
 *
 * Returns the tight crop represented by an AABB or oriented in-stock detection.
 */
export const appsInStockReviewApiGetDetectionCrop = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiGetDetectionCropData, ThrowOnError>) => (options.client ?? client).get<AppsInStockReviewApiGetDetectionCropResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/detections/{detection_id}/crop',
    ...options
});

/**
 * Add Frame Hard Negatives
 *
 * Marks every detection on a frame as a hard negative against the job's product_set.
 */
export const appsInStockReviewApiAddFrameHardNegatives = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiAddFrameHardNegativesData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiAddFrameHardNegativesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/frames/hard-negatives',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Detection Recognizer Debug
 *
 * Recomputes per-retriever (DINO, OCR) and fused top-K for one detection.
 *
 * Powers the product recognizer debug viewer: shows the raw FAISS top-K, the raw
 * trigram-OCR top-K, and the fused top-K the recognizer actually emits. Recomputes
 * everything on demand (Triton + Cloud Vision + FAISS + trigram), so multi-second
 * latency is expected.
 */
export const appsInStockReviewApiGetDetectionRecognizerDebug = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiGetDetectionRecognizerDebugData, ThrowOnError>) => (options.client ?? client).get<AppsInStockReviewApiGetDetectionRecognizerDebugResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/detections/{detection_id}/recognizer-debug',
    ...options
});

/**
 * List Completed Jobs
 *
 * Lists completed InStockVerificationJobs grouped by their audit.
 */
export const appsInStockReviewApiListCompletedJobs = <ThrowOnError extends boolean = false>(options?: Options<AppsInStockReviewApiListCompletedJobsData, ThrowOnError>) => (options?.client ?? client).get<AppsInStockReviewApiListCompletedJobsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs-completed',
    ...options
});

/**
 * List Job Products
 *
 * Returns the job's product set split by whether a verification task exists.
 */
export const appsInStockReviewApiListJobProducts = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiListJobProductsData, ThrowOnError>) => (options.client ?? client).get<AppsInStockReviewApiListJobProductsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/products',
    ...options
});

/**
 * Get Product Evidence
 *
 * The evidence for a product in this job, optionally filtered by display.
 */
export const appsInStockReviewApiGetProductEvidence = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiGetProductEvidenceData, ThrowOnError>) => (options.client ?? client).get<AppsInStockReviewApiGetProductEvidenceResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/products/{product_id}/evidence',
    ...options
});

/**
 * Get Metrics Overview
 *
 * Headline precision/recall summary plus per-job timeline.
 */
export const appsInStockReviewApiGetMetricsOverview = <ThrowOnError extends boolean = false>(options?: Options<AppsInStockReviewApiGetMetricsOverviewData, ThrowOnError>) => (options?.client ?? client).get<AppsInStockReviewApiGetMetricsOverviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/metrics',
    ...options
});

/**
 * Get Product Set Accuracy
 *
 * Per-product review history and confusion matrix across the set's completed jobs.
 */
export const appsInStockReviewApiGetProductSetAccuracy = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiGetProductSetAccuracyData, ThrowOnError>) => (options.client ?? client).get<AppsInStockReviewApiGetProductSetAccuracyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/product-sets/{product_set_id}/accuracy',
    ...options
});

/**
 * Set Ground Truth
 *
 * Upserts the QA ground-truth verdict for a product within a job.
 */
export const appsInStockReviewApiSetGroundTruth = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiSetGroundTruthData, ThrowOnError>) => (options.client ?? client).put<AppsInStockReviewApiSetGroundTruthResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/products/{product_id}/ground-truth',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Quality Control
 */
export const appsInStockReviewApiSetQualityControl = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiSetQualityControlData, ThrowOnError>) => (options.client ?? client).put<AppsInStockReviewApiSetQualityControlResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/products/{product_id}/quality-control',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Job Result
 *
 * Corrects a product's job result by hand.
 *
 * This updates the result only to CANNOT_DETERMINE. Both IN_STOCK and OUT_OF_STOCK require
 * location evidence and are set through the out-of-stock confirmation page.
 */
export const appsInStockReviewApiSetJobResult = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiSetJobResultData, ThrowOnError>) => (options.client ?? client).put<AppsInStockReviewApiSetJobResultResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/products/{product_id}/result',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Auto Approval Simulation
 *
 * Scores a read-only threshold replay over the candidates surfaced for human review.
 */
export const appsInStockReviewApiAutoApprovalSimulation = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiAutoApprovalSimulationData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiAutoApprovalSimulationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/auto-approval-simulation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Label Export
 *
 * Triggers an async GCS export of all trusted in-stock review labels and all hard negatives.
 *
 * Returns immediately with the `gs://` URI under which the export will be written.
 * The manifest.json written last signals a complete export.
 */
export const appsInStockReviewApiCreateLabelExport = <ThrowOnError extends boolean = false>(options?: Options<AppsInStockReviewApiCreateLabelExportData, ThrowOnError>) => (options?.client ?? client).post<AppsInStockReviewApiCreateLabelExportResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/label-exports',
    ...options
});

/**
 * Create Verification Job
 *
 * Creates the job for a pipeline run (idempotent on `job_id` — retries resume it).
 */
export const appsInStockReviewApiCreateVerificationJob = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiCreateVerificationJobData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiCreateVerificationJobResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register Pipeline Display Instances
 *
 * Registers a frame's display instances.
 */
export const appsInStockReviewApiRegisterPipelineDisplayInstances = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiRegisterPipelineDisplayInstancesData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiRegisterPipelineDisplayInstancesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/display-instances',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Save Pipeline Detections
 *
 * Bulk-saves one chunk of detection rows (idempotent via deterministic detection ids).
 */
export const appsInStockReviewApiSavePipelineDetections = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiSavePipelineDetectionsData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiSavePipelineDetectionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/detections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete Pipeline Job
 *
 * Persists per-product results, creates verification tasks, and finalizes the job.
 */
export const appsInStockReviewApiCompletePipelineJob = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiCompletePipelineJobData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiCompletePipelineJobResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fail Pipeline Job
 *
 * Marks the job FAILED with the pipeline's error message (never clobbers a finalized job).
 */
export const appsInStockReviewApiFailPipelineJob = <ThrowOnError extends boolean = false>(options: Options<AppsInStockReviewApiFailPipelineJobData, ThrowOnError>) => (options.client ?? client).post<AppsInStockReviewApiFailPipelineJobResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/in-stock-review/jobs/{job_id}/fail',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Store Groups
 *
 * Lists the petrol store groups this company is audited on.
 */
export const appsPetrolReviewClientApiListStoreGroups = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewClientApiListStoreGroupsData, ThrowOnError>) => (options.client ?? client).get<AppsPetrolReviewClientApiListStoreGroupsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-results/{company_slug}/store-groups',
    ...options
});

/**
 * List Audits
 *
 * Lists one store group's reviewed audits, newest audit first.
 */
export const appsPetrolReviewClientApiListAudits = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewClientApiListAuditsData, ThrowOnError>) => (options.client ?? client).get<AppsPetrolReviewClientApiListAuditsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-results/{company_slug}/audits',
    ...options
});

/**
 * Get Results
 *
 * Returns one store group's reviewed results, or one location's when `store_id` is given.
 */
export const appsPetrolReviewClientApiGetResults = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewClientApiGetResultsData, ThrowOnError>) => (options.client ?? client).get<AppsPetrolReviewClientApiGetResultsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-results/{company_slug}/results',
    ...options
});

/**
 * Get Audit Review
 *
 * Returns one audit's signed-off review; staff also read an unpublished one, to preview it.
 */
export const appsPetrolReviewClientApiGetAuditReview = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewClientApiGetAuditReviewData, ThrowOnError>) => (options.client ?? client).get<AppsPetrolReviewClientApiGetAuditReviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-results/{company_slug}/audits/{audit_id}/review',
    ...options
});

/**
 * List Petrol Reviews
 *
 * Per-audit petrol-review overview, paginated: each audit's latest completed run, the station it
 * was recorded at, its task counts, and its review/completion state. Sorting and filtering run in
 * the database, so they span the whole list rather than one page.
 */
export const appsPetrolReviewReviewApiListPetrolReviews = <ThrowOnError extends boolean = false>(options?: Options<AppsPetrolReviewReviewApiListPetrolReviewsData, ThrowOnError>) => (options?.client ?? client).get<AppsPetrolReviewReviewApiListPetrolReviewsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/reviews',
    ...options
});

/**
 * Complete Review
 *
 * Finalize an audit's human review by materializing its report from the caller's workspace.
 */
export const appsPetrolReviewReviewApiCompleteReview = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewReviewApiCompleteReviewData, ThrowOnError>) => (options.client ?? client).post<AppsPetrolReviewReviewApiCompleteReviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/process-audit/{audit_id}/complete-review',
    ...options
});

/**
 * Reopen Review
 *
 * Reopen a completed review: the snapshot goes, its workspace becomes editable again, verdicts
 * survive. Idempotent — a no-op when there's nothing to reopen.
 */
export const appsPetrolReviewReviewApiReopenReview = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewReviewApiReopenReviewData, ThrowOnError>) => (options.client ?? client).post<AppsPetrolReviewReviewApiReopenReviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/process-audit/{audit_id}/reopen-review',
    ...options
});

/**
 * Publish Review
 *
 * Release a completed review to the customer, or unpublish it.
 */
export const appsPetrolReviewReviewApiPublishReview = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewReviewApiPublishReviewData, ThrowOnError>) => (options.client ?? client).post<AppsPetrolReviewReviewApiPublishReviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/process-audit/{audit_id}/publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Audit Result
 *
 * Return the latest finalized review result for an audit, with signed URLs for evidence frames.
 */
export const appsPetrolReviewReviewApiGetAuditResult = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewReviewApiGetAuditResultData, ThrowOnError>) => (options.client ?? client).get<AppsPetrolReviewReviewApiGetAuditResultResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/process-audit/{audit_id}/result',
    ...options
});

/**
 * Get Audit Tasks
 *
 * The caller's workspace tasks (one per rubric item) for the run being reviewed.
 *
 * A completed review serves the workspace it was compiled from instead, so its verdicts stay
 * visible to every viewer.
 */
export const appsPetrolReviewReviewApiGetAuditTasks = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewReviewApiGetAuditTasksData, ThrowOnError>) => (options.client ?? client).get<AppsPetrolReviewReviewApiGetAuditTasksResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/process-audit/{audit_id}/tasks',
    ...options
});

/**
 * Review Task
 *
 * Persist a reviewer's verdict on one petrol task. Idempotent from any current status.
 */
export const appsPetrolReviewReviewApiReviewTask = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewReviewApiReviewTaskData, ThrowOnError>) => (options.client ?? client).post<AppsPetrolReviewReviewApiReviewTaskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/audits/{audit_id}/tasks/{task_id}/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Review Pump Check
 *
 * Review or APPEND a per-pump check, creating its task on demand if the model never produced one.
 */
export const appsPetrolReviewReviewApiReviewPumpCheck = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewReviewApiReviewPumpCheckData, ThrowOnError>) => (options.client ?? client).post<AppsPetrolReviewReviewApiReviewPumpCheckResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/audits/{audit_id}/pump-checks/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Pump Frames
 *
 * Drop a pump's saved gallery (when the reviewer removes or renames that pump).
 */
export const appsPetrolReviewReviewApiDeletePumpFrames = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewReviewApiDeletePumpFramesData, ThrowOnError>) => (options.client ?? client).delete<AppsPetrolReviewReviewApiDeletePumpFramesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/audits/{audit_id}/pumps/{pump_id}/frames',
    ...options
});

/**
 * Save Pump Frames
 *
 * Save the reviewer's frame gallery for one pump (the single source of truth for its evidence).
 *
 * Called when a pump is accepted in the frames step; upserts this pump's row on the session
 * without disturbing the others.
 */
export const appsPetrolReviewReviewApiSavePumpFrames = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewReviewApiSavePumpFramesData, ThrowOnError>) => (options.client ?? client).put<AppsPetrolReviewReviewApiSavePumpFramesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/audits/{audit_id}/pumps/{pump_id}/frames',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Pump Count
 *
 * Set how many pump slots this audit has
 */
export const appsPetrolReviewReviewApiUpdatePumpCount = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewReviewApiUpdatePumpCountData, ThrowOnError>) => (options.client ?? client).put<AppsPetrolReviewReviewApiUpdatePumpCountResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/audits/{audit_id}/pump-roster',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Audit Frames
 *
 * List every extracted frame for the audit's latest review, grouped by camera, with signed URLs.
 */
export const appsPetrolReviewReviewFramesGetAuditFrames = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewReviewFramesGetAuditFramesData, ThrowOnError>) => (options.client ?? client).get<AppsPetrolReviewReviewFramesGetAuditFramesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/process-audit/{audit_id}/frames',
    ...options
});

/**
 * Search Audit Frames
 *
 * Semantic frame search: embed a text query and return the top-K matching frames.
 */
export const appsPetrolReviewReviewSearchSearchAuditFrames = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewReviewSearchSearchAuditFramesData, ThrowOnError>) => (options.client ?? client).get<AppsPetrolReviewReviewSearchSearchAuditFramesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/process-audit/{audit_id}/frames/search',
    ...options
});

/**
 * Get Metrics
 */
export const appsPetrolReviewInternalApiGetMetrics = <ThrowOnError extends boolean = false>(options?: Options<AppsPetrolReviewInternalApiGetMetricsData, ThrowOnError>) => (options?.client ?? client).get<AppsPetrolReviewInternalApiGetMetricsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/metrics',
    ...options
});

/**
 * Trigger Review
 *
 * Manually start a petrol review for an audit (staff), kicking off the REVIEW Cloud Workflow.
 */
export const appsPetrolReviewInternalApiTriggerReview = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewInternalApiTriggerReviewData, ThrowOnError>) => (options.client ?? client).post<AppsPetrolReviewInternalApiTriggerReviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/audits/{audit_id}/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Audit Videos
 *
 * Per-camera walkthrough videos: the downsampled `cache/` proxy (snappy) and the full-res
 * source recording. Both signed; a player would default to the proxy and offer full on demand.
 */
export const appsPetrolReviewInternalApiGetAuditVideos = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewInternalApiGetAuditVideosData, ThrowOnError>) => (options.client ?? client).get<AppsPetrolReviewInternalApiGetAuditVideosResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/audits/{audit_id}/videos',
    ...options
});

/**
 * List Asset Types
 *
 * The shared catalog of asset types available to question-set authors.
 */
export const appsPetrolReviewInternalQuestionSetsListAssetTypes = <ThrowOnError extends boolean = false>(options?: Options<AppsPetrolReviewInternalQuestionSetsListAssetTypesData, ThrowOnError>) => (options?.client ?? client).get<AppsPetrolReviewInternalQuestionSetsListAssetTypesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/asset-types',
    ...options
});

/**
 * Create Asset Type
 */
export const appsPetrolReviewInternalQuestionSetsCreateAssetType = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewInternalQuestionSetsCreateAssetTypeData, ThrowOnError>) => (options.client ?? client).post<AppsPetrolReviewInternalQuestionSetsCreateAssetTypeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/asset-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Asset Type
 */
export const appsPetrolReviewInternalQuestionSetsDeleteAssetType = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewInternalQuestionSetsDeleteAssetTypeData, ThrowOnError>) => (options.client ?? client).delete<AppsPetrolReviewInternalQuestionSetsDeleteAssetTypeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/asset-types/{key}',
    ...options
});

/**
 * Update Asset Type
 */
export const appsPetrolReviewInternalQuestionSetsUpdateAssetType = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewInternalQuestionSetsUpdateAssetTypeData, ThrowOnError>) => (options.client ?? client).patch<AppsPetrolReviewInternalQuestionSetsUpdateAssetTypeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/asset-types/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Question Sets
 *
 * All question-set versions (management overview), optionally filtered by scope or active state.
 */
export const appsPetrolReviewInternalQuestionSetsListQuestionSets = <ThrowOnError extends boolean = false>(options?: Options<AppsPetrolReviewInternalQuestionSetsListQuestionSetsData, ThrowOnError>) => (options?.client ?? client).get<AppsPetrolReviewInternalQuestionSetsListQuestionSetsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/question-sets',
    ...options
});

/**
 * Upload Question Set
 *
 * Upload an audit question set.
 *
 * Question sets are versioned and scoped to a company (and an optional store group); each upload
 * creates a new version rather than mutating an existing one.
 */
export const appsPetrolReviewInternalQuestionSetsUploadQuestionSet = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewInternalQuestionSetsUploadQuestionSetData, ThrowOnError>) => (options.client ?? client).post<AppsPetrolReviewInternalQuestionSetsUploadQuestionSetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/question-sets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activate Question Set
 *
 * Make this question set the active one for its (kind, company, store group) scope.
 *
 * Deactivates the previously-active version in the same scope.
 */
export const appsPetrolReviewInternalQuestionSetsActivateQuestionSet = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewInternalQuestionSetsActivateQuestionSetData, ThrowOnError>) => (options.client ?? client).post<AppsPetrolReviewInternalQuestionSetsActivateQuestionSetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/question-sets/{question_set_id}/activate',
    ...options
});

/**
 * Deactivate Question Set
 *
 * Clear the active flag on this set, leaving its scope with no active rubric.
 */
export const appsPetrolReviewInternalQuestionSetsDeactivateQuestionSet = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewInternalQuestionSetsDeactivateQuestionSetData, ThrowOnError>) => (options.client ?? client).post<AppsPetrolReviewInternalQuestionSetsDeactivateQuestionSetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/question-sets/{question_set_id}/deactivate',
    ...options
});

/**
 * Clone Into Sandbox
 *
 * Atomically clone completed petrol runs into a sandbox as fresh review work.
 */
export const appsPetrolReviewInternalSandboxCloneIntoSandbox = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewInternalSandboxCloneIntoSandboxData, ThrowOnError>) => (options.client ?? client).post<AppsPetrolReviewInternalSandboxCloneIntoSandboxResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/sandbox-audits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Sandbox Audit
 *
 * Remove one sandbox clone and the station created for it.
 */
export const appsPetrolReviewInternalSandboxDeleteSandboxAudit = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewInternalSandboxDeleteSandboxAuditData, ThrowOnError>) => (options.client ?? client).delete<AppsPetrolReviewInternalSandboxDeleteSandboxAuditResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/sandbox-audits/{audit_id}',
    ...options
});

/**
 * Get Question Set
 */
export const appsPetrolReviewSharedApiGetQuestionSet = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewSharedApiGetQuestionSetData, ThrowOnError>) => (options.client ?? client).get<AppsPetrolReviewSharedApiGetQuestionSetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/question-sets/{question_set_id}',
    ...options
});

/**
 * Update Question Set
 *
 * Update a question set in place; does not create a new version.
 */
export const appsPetrolReviewSharedApiUpdateQuestionSet = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewSharedApiUpdateQuestionSetData, ThrowOnError>) => (options.client ?? client).patch<AppsPetrolReviewSharedApiUpdateQuestionSetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/question-sets/{question_set_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Review Rubric
 *
 * Return the rubric pinned to a review run, transitioning a PENDING run to PROCESSING.
 */
export const appsPetrolReviewPipelineApiGetReviewRubric = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewPipelineApiGetReviewRubricData, ThrowOnError>) => (options.client ?? client).get<AppsPetrolReviewPipelineApiGetReviewRubricResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/review-runs/{run_id}/rubric',
    ...options
});

/**
 * Post Review Result
 *
 * Ingest the cv pipeline's structured review result for a run and fan it out into tasks.
 */
export const appsPetrolReviewPipelineApiPostReviewResult = <ThrowOnError extends boolean = false>(options: Options<AppsPetrolReviewPipelineApiPostReviewResultData, ThrowOnError>) => (options.client ?? client).post<AppsPetrolReviewPipelineApiPostReviewResultResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/petrol-review/review-runs/{run_id}/result',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Index
 */
export const appsProductRecognizerApiCreateIndex = <ThrowOnError extends boolean = false>(options: Options<AppsProductRecognizerApiCreateIndexData, ThrowOnError>) => (options.client ?? client).post<AppsProductRecognizerApiCreateIndexResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-recognizer/indices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Index
 */
export const appsProductRecognizerApiGetIndex = <ThrowOnError extends boolean = false>(options: Options<AppsProductRecognizerApiGetIndexData, ThrowOnError>) => (options.client ?? client).get<AppsProductRecognizerApiGetIndexResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-recognizer/indices/{index_id}',
    ...options
});

/**
 * Rebuild Index
 */
export const appsProductRecognizerApiRebuildIndex = <ThrowOnError extends boolean = false>(options: Options<AppsProductRecognizerApiRebuildIndexData, ThrowOnError>) => (options.client ?? client).post<AppsProductRecognizerApiRebuildIndexResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-recognizer/indices/{index_id}/rebuild',
    ...options
});

/**
 * Query
 */
export const appsProductRecognizerApiQuery = <ThrowOnError extends boolean = false>(options: Options<AppsProductRecognizerApiQueryData, ThrowOnError>) => (options.client ?? client).post<AppsProductRecognizerApiQueryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-recognizer/query',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Batch Create Products
 */
export const appsProductRecognizerApiBatchCreateProducts = <ThrowOnError extends boolean = false>(options: Options<AppsProductRecognizerApiBatchCreateProductsData, ThrowOnError>) => (options.client ?? client).post<AppsProductRecognizerApiBatchCreateProductsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-recognizer/products/batch-create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Batch Get Products
 */
export const appsProductRecognizerApiBatchGetProducts = <ThrowOnError extends boolean = false>(options: Options<AppsProductRecognizerApiBatchGetProductsData, ThrowOnError>) => (options.client ?? client).post<AppsProductRecognizerApiBatchGetProductsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/product-recognizer/products/batch-get',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Product
 */
export const appsProductRecognizerApiGetProduct = <ThrowOnError extends boolean = false>(options: Options<AppsProductRecognizerApiGetProductData, ThrowOnError>) => (options.client ?? client).get<AppsProductRecognizerApiGetProductResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-recognizer/products/{product_id}',
    ...options
});

/**
 * Get Product Images
 */
export const appsProductRecognizerApiGetProductImages = <ThrowOnError extends boolean = false>(options: Options<AppsProductRecognizerApiGetProductImagesData, ThrowOnError>) => (options.client ?? client).get<AppsProductRecognizerApiGetProductImagesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-recognizer/products/{product_id}/images',
    ...options
});

/**
 * Add Product Image
 */
export const appsProductRecognizerApiAddProductImage = <ThrowOnError extends boolean = false>(options: Options<AppsProductRecognizerApiAddProductImageData, ThrowOnError>) => (options.client ?? client).post<AppsProductRecognizerApiAddProductImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-recognizer/products/{product_id}/images',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Product Image
 */
export const appsProductRecognizerApiUploadProductImage = <ThrowOnError extends boolean = false>(options: Options<AppsProductRecognizerApiUploadProductImageData, ThrowOnError>) => (options.client ?? client).post<AppsProductRecognizerApiUploadProductImageResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-recognizer/products/{product_id}/images/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete Product Image
 *
 * Deletes a ProductImage row.
 *
 * For images we created via the upload endpoint (under ``catalog-uploads/`` in the
 * primary bucket), the underlying GCS blob is also deleted — but only when no other
 * ProductImage row still references it. Externally-supplied ``gs://`` URLs are left
 * alone since we don't own those blobs.
 */
export const appsProductRecognizerApiDeleteProductImage = <ThrowOnError extends boolean = false>(options: Options<AppsProductRecognizerApiDeleteProductImageData, ThrowOnError>) => (options.client ?? client).delete<AppsProductRecognizerApiDeleteProductImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-recognizer/products/{product_id}/images/{image_id}',
    ...options
});

/**
 * Set Primary Product Image
 *
 * Marks a ProductImage as the product's primary, unsetting any previous primary.
 */
export const appsProductRecognizerApiSetPrimaryProductImage = <ThrowOnError extends boolean = false>(options: Options<AppsProductRecognizerApiSetPrimaryProductImageData, ThrowOnError>) => (options.client ?? client).post<AppsProductRecognizerApiSetPrimaryProductImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-recognizer/products/{product_id}/images/{image_id}/primary',
    ...options
});

/**
 * List Product Sets
 */
export const appsProductRecognizerApiListProductSets = <ThrowOnError extends boolean = false>(options?: Options<AppsProductRecognizerApiListProductSetsData, ThrowOnError>) => (options?.client ?? client).get<AppsProductRecognizerApiListProductSetsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-recognizer/product-sets',
    ...options
});

/**
 * Create Product Set
 */
export const appsProductRecognizerApiCreateProductSet = <ThrowOnError extends boolean = false>(options: Options<AppsProductRecognizerApiCreateProductSetData, ThrowOnError>) => (options.client ?? client).post<AppsProductRecognizerApiCreateProductSetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-recognizer/product-sets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Product Set
 */
export const appsProductRecognizerApiDeleteProductSet = <ThrowOnError extends boolean = false>(options: Options<AppsProductRecognizerApiDeleteProductSetData, ThrowOnError>) => (options.client ?? client).delete<AppsProductRecognizerApiDeleteProductSetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-recognizer/product-sets/{product_set_id}',
    ...options
});

/**
 * Get Product Set
 */
export const appsProductRecognizerApiGetProductSet = <ThrowOnError extends boolean = false>(options: Options<AppsProductRecognizerApiGetProductSetData, ThrowOnError>) => (options.client ?? client).get<AppsProductRecognizerApiGetProductSetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/product-recognizer/product-sets/{product_set_id}',
    ...options
});

/**
 * Update Product Set
 */
export const appsProductRecognizerApiUpdateProductSet = <ThrowOnError extends boolean = false>(options: Options<AppsProductRecognizerApiUpdateProductSetData, ThrowOnError>) => (options.client ?? client).put<AppsProductRecognizerApiUpdateProductSetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-recognizer/product-sets/{product_set_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Products
 */
export const appsProductRecognizerApiListProducts = <ThrowOnError extends boolean = false>(options: Options<AppsProductRecognizerApiListProductsData, ThrowOnError>) => (options.client ?? client).get<AppsProductRecognizerApiListProductsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-recognizer/product-sets/{product_set_id}/products',
    ...options
});

/**
 * List Indices
 */
export const appsProductRecognizerApiListIndices = <ThrowOnError extends boolean = false>(options: Options<AppsProductRecognizerApiListIndicesData, ThrowOnError>) => (options.client ?? client).get<AppsProductRecognizerApiListIndicesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-recognizer/product-sets/{product_set_id}/recognition-indices',
    ...options
});

/**
 * List All Stores
 *
 * Returns a paginated list of stores for the given company.
 *
 * Used for staff tooling.
 */
export const appsStoresApiListAllStores = <ThrowOnError extends boolean = false>(options: Options<AppsStoresApiListAllStoresData, ThrowOnError>) => (options.client ?? client).get<AppsStoresApiListAllStoresResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/stores/all',
    ...options
});

/**
 * Create Store
 *
 * Creates a store and adds it to the given store groups.
 */
export const appsStoresApiCreateStore = <ThrowOnError extends boolean = false>(options: Options<AppsStoresApiCreateStoreData, ThrowOnError>) => (options.client ?? client).post<AppsStoresApiCreateStoreResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/stores/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List All Store Groups
 *
 * Returns all store groups across every company, optionally filtered to one company.
 */
export const appsStoresApiListAllStoreGroups = <ThrowOnError extends boolean = false>(options?: Options<AppsStoresApiListAllStoreGroupsData, ThrowOnError>) => (options?.client ?? client).get<AppsStoresApiListAllStoreGroupsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/stores/groups/all',
    ...options
});

/**
 * Create Store Group
 *
 * Creates a store group and attaches the given companies.
 */
export const appsStoresApiCreateStoreGroup = <ThrowOnError extends boolean = false>(options: Options<AppsStoresApiCreateStoreGroupData, ThrowOnError>) => (options.client ?? client).post<AppsStoresApiCreateStoreGroupResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/stores/groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Nearby Stores
 *
 * Returns a list of nearby stores within the configured radius.
 *
 * This endpoint is used by auditors via the app, therefore it only returns stores
 * that the user can audit.
 *
 * Returns:
 * List of nearby stores sorted by distance ascending.
 */
export const appsStoresApiGetNearbyStores = <ThrowOnError extends boolean = false>(options: Options<AppsStoresApiGetNearbyStoresData, ThrowOnError>) => (options.client ?? client).get<AppsStoresApiGetNearbyStoresResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/stores/nearby',
    ...options
});

/**
 * Get Nearby Stores All
 *
 * Returns stores across all companies within the requested radius, sorted by distance.
 */
export const appsStoresApiGetNearbyStoresAll = <ThrowOnError extends boolean = false>(options: Options<AppsStoresApiGetNearbyStoresAllData, ThrowOnError>) => (options.client ?? client).get<AppsStoresApiGetNearbyStoresAllResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/stores/nearby/all',
    ...options
});

/**
 * Import Stores
 *
 * Batch import stores into a store group. Idempotent via external_id.
 */
export const appsStoresApiImportStores = <ThrowOnError extends boolean = false>(options: Options<AppsStoresApiImportStoresData, ThrowOnError>) => (options.client ?? client).post<AppsStoresApiImportStoresResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/stores/groups/{group_slug}/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ingest Telemetry
 */
export const appsTelemetryApiIngestTelemetry = <ThrowOnError extends boolean = false>(options: Options<AppsTelemetryApiIngestTelemetryData, ThrowOnError>) => (options.client ?? client).post<AppsTelemetryApiIngestTelemetryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/telemetry/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Device Logs
 */
export const appsTelemetryApiListDeviceLogs = <ThrowOnError extends boolean = false>(options: Options<AppsTelemetryApiListDeviceLogsData, ThrowOnError>) => (options.client ?? client).get<AppsTelemetryApiListDeviceLogsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/telemetry/logs/',
    ...options
});

/**
 * Get Current User
 */
export const appsUsersApiGetCurrentUser = <ThrowOnError extends boolean = false>(options?: Options<AppsUsersApiGetCurrentUserData, ThrowOnError>) => (options?.client ?? client).get<AppsUsersApiGetCurrentUserResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/users/me',
    ...options
});

/**
 * Create Invitation
 */
export const appsUsersApiCreateInvitation = <ThrowOnError extends boolean = false>(options: Options<AppsUsersApiCreateInvitationData, ThrowOnError>) => (options.client ?? client).post<AppsUsersApiCreateInvitationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/users/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate Invitation
 */
export const appsUsersApiValidateInvitation = <ThrowOnError extends boolean = false>(options: Options<AppsUsersApiValidateInvitationData, ThrowOnError>) => (options.client ?? client).get<AppsUsersApiValidateInvitationResponses, unknown, ThrowOnError>({ url: '/v0/users/invitations/{token}', ...options });

/**
 * Accept Invitation
 */
export const appsUsersApiAcceptInvitation = <ThrowOnError extends boolean = false>(options: Options<AppsUsersApiAcceptInvitationData, ThrowOnError>) => (options.client ?? client).post<AppsUsersApiAcceptInvitationResponses, unknown, ThrowOnError>({
    url: '/v0/users/invitations/{token}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deactivate Push Token
 *
 * Deactivate a push notification token (e.g., when user logs out).
 *
 * This performs a soft delete by setting is_active=False.
 * The token can be reactivated later if the user logs back in.
 */
export const appsUsersApiDeactivatePushToken = <ThrowOnError extends boolean = false>(options: Options<AppsUsersApiDeactivatePushTokenData, ThrowOnError>) => (options.client ?? client).delete<AppsUsersApiDeactivatePushTokenResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/users/push-tokens',
    ...options
});

/**
 * Register Push Token
 *
 * Register or update a push notification token for the current user.
 *
 * This endpoint handles:
 * - New token registration
 * - Token refresh (same token, update metadata)
 * - Device handover (same token, different user)
 * - Reactivating previously deactivated tokens
 */
export const appsUsersApiRegisterPushToken = <ThrowOnError extends boolean = false>(options: Options<AppsUsersApiRegisterPushTokenData, ThrowOnError>) => (options.client ?? client).post<AppsUsersApiRegisterPushTokenResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/users/push-tokens',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trigger Tracking
 *
 * Triggers background video processing for a single recording.
 */
export const appsProductTrackLabelingApiTriggerTracking = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingApiTriggerTrackingData, ThrowOnError>) => (options.client ?? client).post<AppsProductTrackLabelingApiTriggerTrackingResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/process-tracking',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Probe Source
 *
 * Probes a GCS source and returns the video(s) the pipeline would process, with metadata.
 *
 * Accepts a single video object or a directory prefix. Each returned video carries fps/duration
 * (or a per-video `error` if it couldn't be probed).
 */
export const appsProductTrackLabelingApiProbeSource = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingApiProbeSourceData, ThrowOnError>) => (options.client ?? client).post<AppsProductTrackLabelingApiProbeSourceResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/probe-source',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Tracking Job
 *
 * Returns the status of a track labeling processing job.
 */
export const appsProductTrackLabelingApiGetTrackingJob = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingApiGetTrackingJobData, ThrowOnError>) => (options.client ?? client).get<AppsProductTrackLabelingApiGetTrackingJobResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/process-tracking/{job_id}',
    ...options
});

/**
 * Get Tracking Job Results
 *
 * Returns a paginated list of a track labeling job's labeling results.
 */
export const appsProductTrackLabelingApiGetTrackingJobResults = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingApiGetTrackingJobResultsData, ThrowOnError>) => (options.client ?? client).get<AppsProductTrackLabelingApiGetTrackingJobResultsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/process-tracking/{job_id}/results',
    ...options
});

/**
 * Get Overview
 *
 * Returns label coverage stats and a histogram of confirmed labels per product.
 */
export const appsProductTrackLabelingLabelExplorerApiGetOverview = <ThrowOnError extends boolean = false>(options?: Options<AppsProductTrackLabelingLabelExplorerApiGetOverviewData, ThrowOnError>) => (options?.client ?? client).get<AppsProductTrackLabelingLabelExplorerApiGetOverviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-explorer/overview',
    ...options
});

/**
 * List Product Sets
 *
 * Returns all product sets with their product counts, for use in filter dropdowns.
 */
export const appsProductTrackLabelingLabelExplorerApiListProductSets = <ThrowOnError extends boolean = false>(options?: Options<AppsProductTrackLabelingLabelExplorerApiListProductSetsData, ThrowOnError>) => (options?.client ?? client).get<AppsProductTrackLabelingLabelExplorerApiListProductSetsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-explorer/product-sets',
    ...options
});

/**
 * List Products
 *
 * Returns a paginated list of products with their confirmed track and crop counts.
 */
export const appsProductTrackLabelingLabelExplorerApiListProducts = <ThrowOnError extends boolean = false>(options?: Options<AppsProductTrackLabelingLabelExplorerApiListProductsData, ThrowOnError>) => (options?.client ?? client).get<AppsProductTrackLabelingLabelExplorerApiListProductsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-explorer/products',
    ...options
});

/**
 * Get Product Track Labels
 *
 * Returns a paginated list of labeling results for a specific product.
 */
export const appsProductTrackLabelingLabelExplorerApiGetProductTrackLabels = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelExplorerApiGetProductTrackLabelsData, ThrowOnError>) => (options.client ?? client).get<AppsProductTrackLabelingLabelExplorerApiGetProductTrackLabelsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-explorer/products/{product_id}/track-labels',
    ...options
});

/**
 * Get Track Detail
 *
 * Returns every labeled frame of one track plus its current product and same-cluster relabel suggestions.
 */
export const appsProductTrackLabelingLabelExplorerApiGetTrackDetail = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelExplorerApiGetTrackDetailData, ThrowOnError>) => (options.client ?? client).get<AppsProductTrackLabelingLabelExplorerApiGetTrackDetailResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-explorer/track-labels/{result_id}',
    ...options
});

/**
 * Remove Track Product
 *
 * Removes the track's product by setting its label to SKIPPED, recording the staff user in its history.
 */
export const appsProductTrackLabelingLabelExplorerApiRemoveTrackProduct = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelExplorerApiRemoveTrackProductData, ThrowOnError>) => (options.client ?? client).delete<AppsProductTrackLabelingLabelExplorerApiRemoveTrackProductResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-explorer/track-labels/{result_id}/product',
    ...options
});

/**
 * Reassign Track Product
 *
 * Manually (re)assigns the product on a track and marks it CONFIRMED, recording the staff user in its history.
 *
 * Durable: a labeling task can only be completed once (labeling.service.complete), so a labeler's answer
 * never overwrites this.
 */
export const appsProductTrackLabelingLabelExplorerApiReassignTrackProduct = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelExplorerApiReassignTrackProductData, ThrowOnError>) => (options.client ?? client).put<AppsProductTrackLabelingLabelExplorerApiReassignTrackProductResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-explorer/track-labels/{result_id}/product',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List In Stock Review Labels
 *
 * Returns in-stock-review product labels, newest first, narrowed by the query's filters.
 */
export const appsProductTrackLabelingLabelExplorerApiListInStockReviewLabels = <ThrowOnError extends boolean = false>(options?: Options<AppsProductTrackLabelingLabelExplorerApiListInStockReviewLabelsData, ThrowOnError>) => (options?.client ?? client).get<AppsProductTrackLabelingLabelExplorerApiListInStockReviewLabelsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-explorer/in-stock-review-labels',
    ...options
});

/**
 * List In Stock Review Labelers
 *
 * Returns every user who wrote an in-stock-review label.
 */
export const appsProductTrackLabelingLabelExplorerApiListInStockReviewLabelers = <ThrowOnError extends boolean = false>(options?: Options<AppsProductTrackLabelingLabelExplorerApiListInStockReviewLabelersData, ThrowOnError>) => (options?.client ?? client).get<AppsProductTrackLabelingLabelExplorerApiListInStockReviewLabelersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-explorer/in-stock-review-labelers',
    ...options
});

/**
 * Delete In Stock Review Label
 *
 * Deletes a label. Idempotent: deleting a missing label still succeeds.
 */
export const appsProductTrackLabelingLabelExplorerApiDeleteInStockReviewLabel = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelExplorerApiDeleteInStockReviewLabelData, ThrowOnError>) => (options.client ?? client).delete<AppsProductTrackLabelingLabelExplorerApiDeleteInStockReviewLabelResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-explorer/in-stock-review-labels/{label_id}',
    ...options
});

/**
 * Set In Stock Review Label Trust
 *
 * Toggles a label's `is_trusted` field.
 */
export const appsProductTrackLabelingLabelExplorerApiSetInStockReviewLabelTrust = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelExplorerApiSetInStockReviewLabelTrustData, ThrowOnError>) => (options.client ?? client).patch<AppsProductTrackLabelingLabelExplorerApiSetInStockReviewLabelTrustResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-explorer/in-stock-review-labels/{label_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Hard Negatives
 *
 * Returns a paginated list of in-stock-detection hard negatives for a product set.
 */
export const appsProductTrackLabelingLabelExplorerApiListHardNegatives = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelExplorerApiListHardNegativesData, ThrowOnError>) => (options.client ?? client).get<AppsProductTrackLabelingLabelExplorerApiListHardNegativesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-explorer/hard-negatives',
    ...options
});

/**
 * Delete Hard Negative
 *
 * Deletes a hard negative. Idempotent: deleting a missing hard negative still succeeds.
 */
export const appsProductTrackLabelingLabelExplorerApiDeleteHardNegative = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelExplorerApiDeleteHardNegativeData, ThrowOnError>) => (options.client ?? client).delete<AppsProductTrackLabelingLabelExplorerApiDeleteHardNegativeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-explorer/hard-negatives/{hard_negative_id}',
    ...options
});

/**
 * Create Label Export
 *
 * Triggers a bulk export of CONFIRMED track labels to GCS.
 */
export const appsProductTrackLabelingLabelExplorerApiCreateLabelExport = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelExplorerApiCreateLabelExportData, ThrowOnError>) => (options.client ?? client).post<AppsProductTrackLabelingLabelExplorerApiCreateLabelExportResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-explorer/exports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Tasks
 */
export const appsProductTrackLabelingLabelerApiListTasks = <ThrowOnError extends boolean = false>(options?: Options<AppsProductTrackLabelingLabelerApiListTasksData, ThrowOnError>) => (options?.client ?? client).get<AppsProductTrackLabelingLabelerApiListTasksResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/labeler/tasks',
    ...options
});

/**
 * List Product Sets
 *
 * Lists the product sets with tracks pending for labeling.
 */
export const appsProductTrackLabelingLabelerApiListProductSets = <ThrowOnError extends boolean = false>(options?: Options<AppsProductTrackLabelingLabelerApiListProductSetsData, ThrowOnError>) => (options?.client ?? client).get<AppsProductTrackLabelingLabelerApiListProductSetsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/labeler/product-sets',
    ...options
});

/**
 * Next Task
 *
 * Returns the track the requester holds in the product set, or gives them their next task.
 */
export const appsProductTrackLabelingLabelerApiNextTask = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelerApiNextTaskData, ThrowOnError>) => (options.client ?? client).post<AppsProductTrackLabelingLabelerApiNextTaskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/labeler/tasks/next',
    ...options
});

/**
 * Open Task
 */
export const appsProductTrackLabelingLabelerApiOpenTask = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelerApiOpenTaskData, ThrowOnError>) => (options.client ?? client).post<AppsProductTrackLabelingLabelerApiOpenTaskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/labeler/tasks/{labeling_task_id}/open',
    ...options
});

/**
 * Release Task
 */
export const appsProductTrackLabelingLabelerApiReleaseTask = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelerApiReleaseTaskData, ThrowOnError>) => (options.client ?? client).post<AppsProductTrackLabelingLabelerApiReleaseTaskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/labeler/tasks/{labeling_task_id}/release',
    ...options
});

/**
 * Submit Task
 *
 * Submits the requester's answer for a track.
 *
 * If the track was an accuracy check and the requester answered incorrectly, the response
 * will carry the correct answer for frontend feedback loop.
 */
export const appsProductTrackLabelingLabelerApiSubmitTask = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelerApiSubmitTaskData, ThrowOnError>) => (options.client ?? client).post<AppsProductTrackLabelingLabelerApiSubmitTaskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/labeler/tasks/{labeling_task_id}/submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Dispute Task
 *
 * Submits a dispute for an accuracy check.
 */
export const appsProductTrackLabelingLabelerApiDisputeTask = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelerApiDisputeTaskData, ThrowOnError>) => (options.client ?? client).post<AppsProductTrackLabelingLabelerApiDisputeTaskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/labeler/tasks/{labeling_task_id}/dispute',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search Products
 *
 * Lists and searches the track's product set, for picking a product the recognizer didn't propose.
 */
export const appsProductTrackLabelingLabelerApiSearchProducts = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelerApiSearchProductsData, ThrowOnError>) => (options.client ?? client).get<AppsProductTrackLabelingLabelerApiSearchProductsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/labeler/tasks/{labeling_task_id}/products',
    ...options
});

/**
 * Product Images
 *
 * Returns catalog images of a product proposed for the track or in its product set.
 */
export const appsProductTrackLabelingLabelerApiProductImages = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelerApiProductImagesData, ThrowOnError>) => (options.client ?? client).get<AppsProductTrackLabelingLabelerApiProductImagesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/labeler/tasks/{labeling_task_id}/products/{product_id}/images',
    ...options
});

/**
 * List Gold Tracks
 *
 * Lists gold tracks for the given query.
 */
export const appsProductTrackLabelingLabelQualityStaffReviewApiListGoldTracks = <ThrowOnError extends boolean = false>(options?: Options<AppsProductTrackLabelingLabelQualityStaffReviewApiListGoldTracksData, ThrowOnError>) => (options?.client ?? client).get<AppsProductTrackLabelingLabelQualityStaffReviewApiListGoldTracksResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-quality/gold-tracks',
    ...options
});

/**
 * Get Gold Track
 *
 * Gets a gold track's detail, its frames, every answer, its label, gold and disputes.
 */
export const appsProductTrackLabelingLabelQualityStaffReviewApiGetGoldTrack = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelQualityStaffReviewApiGetGoldTrackData, ThrowOnError>) => (options.client ?? client).get<AppsProductTrackLabelingLabelQualityStaffReviewApiGetGoldTrackResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-quality/gold-tracks/{gold_track_id}',
    ...options
});

/**
 * Keep Label
 *
 * Settles a disagreement with keeping the track's current label.
 */
export const appsProductTrackLabelingLabelQualityStaffReviewApiKeepLabel = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelQualityStaffReviewApiKeepLabelData, ThrowOnError>) => (options.client ?? client).post<AppsProductTrackLabelingLabelQualityStaffReviewApiKeepLabelResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-quality/gold-tracks/{gold_track_id}/keep-label',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept Answer
 *
 * Settles a disagreement with one of its answers.
 */
export const appsProductTrackLabelingLabelQualityStaffReviewApiAcceptAnswer = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelQualityStaffReviewApiAcceptAnswerData, ThrowOnError>) => (options.client ?? client).post<AppsProductTrackLabelingLabelQualityStaffReviewApiAcceptAnswerResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-quality/gold-tracks/{gold_track_id}/accept-answer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Relabel
 *
 * Settles a disagreement with staff's own label.
 */
export const appsProductTrackLabelingLabelQualityStaffReviewApiRelabel = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelQualityStaffReviewApiRelabelData, ThrowOnError>) => (options.client ?? client).post<AppsProductTrackLabelingLabelQualityStaffReviewApiRelabelResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-quality/gold-tracks/{gold_track_id}/relabel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Correct Gold Track
 *
 * Changes the product of gold in use or disputed.
 */
export const appsProductTrackLabelingLabelQualityStaffReviewApiCorrectGoldTrack = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelQualityStaffReviewApiCorrectGoldTrackData, ThrowOnError>) => (options.client ?? client).post<AppsProductTrackLabelingLabelQualityStaffReviewApiCorrectGoldTrackResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-quality/gold-tracks/{gold_track_id}/correct',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject Disputes
 *
 * Rejects the open disputes of disputed gold, which goes back in use.
 */
export const appsProductTrackLabelingLabelQualityStaffReviewApiRejectDisputes = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelQualityStaffReviewApiRejectDisputesData, ThrowOnError>) => (options.client ?? client).post<AppsProductTrackLabelingLabelQualityStaffReviewApiRejectDisputesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-quality/gold-tracks/{gold_track_id}/reject-disputes',
    ...options
});

/**
 * Retire Gold Track
 *
 * Takes gold in use or disputed out of gold, optionally taking its label out of training.
 */
export const appsProductTrackLabelingLabelQualityStaffReviewApiRetireGoldTrack = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelQualityStaffReviewApiRetireGoldTrackData, ThrowOnError>) => (options.client ?? client).post<AppsProductTrackLabelingLabelQualityStaffReviewApiRetireGoldTrackResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-quality/gold-tracks/{gold_track_id}/retire',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Waiting Answers
 *
 * Lists provisional answers no one confirmed in time, longest wait first.
 */
export const appsProductTrackLabelingLabelQualityStaffReviewApiListWaitingAnswers = <ThrowOnError extends boolean = false>(options?: Options<AppsProductTrackLabelingLabelQualityStaffReviewApiListWaitingAnswersData, ThrowOnError>) => (options?.client ?? client).get<AppsProductTrackLabelingLabelQualityStaffReviewApiListWaitingAnswersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-quality/waiting-answers',
    ...options
});

/**
 * Accept Waiting Answer
 *
 * Settles a waiting answer by accepting it.
 *
 * 409 when the answer stopped waiting, or a labeler holds its confirmation.
 */
export const appsProductTrackLabelingLabelQualityStaffReviewApiAcceptWaitingAnswer = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelQualityStaffReviewApiAcceptWaitingAnswerData, ThrowOnError>) => (options.client ?? client).post<AppsProductTrackLabelingLabelQualityStaffReviewApiAcceptWaitingAnswerResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-quality/waiting-answers/{original_task_id}/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Relabel Waiting Answer
 *
 * Settles a waiting answer with staff's own label.
 *
 * 409 when the answer stopped waiting, or a labeler holds its confirmation.
 */
export const appsProductTrackLabelingLabelQualityStaffReviewApiRelabelWaitingAnswer = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelQualityStaffReviewApiRelabelWaitingAnswerData, ThrowOnError>) => (options.client ?? client).post<AppsProductTrackLabelingLabelQualityStaffReviewApiRelabelWaitingAnswerResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-quality/waiting-answers/{original_task_id}/relabel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Answers
 *
 * Lists answered tracks, newest answer first.
 */
export const appsProductTrackLabelingLabelQualityStaffReviewApiListAnswers = <ThrowOnError extends boolean = false>(options?: Options<AppsProductTrackLabelingLabelQualityStaffReviewApiListAnswersData, ThrowOnError>) => (options?.client ?? client).get<AppsProductTrackLabelingLabelQualityStaffReviewApiListAnswersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-quality/answers',
    ...options
});

/**
 * List Labeler Stats
 *
 * Lists every labeler's stats in the product set.
 */
export const appsProductTrackLabelingLabelQualityStaffReviewApiListLabelerStats = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelQualityStaffReviewApiListLabelerStatsData, ThrowOnError>) => (options.client ?? client).get<AppsProductTrackLabelingLabelQualityStaffReviewApiListLabelerStatsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-quality/labeler-stats',
    ...options
});

/**
 * Get Answer
 *
 * Gets an answered track's detail, whether or not it has a gold track.
 */
export const appsProductTrackLabelingLabelQualityStaffReviewApiGetAnswer = <ThrowOnError extends boolean = false>(options: Options<AppsProductTrackLabelingLabelQualityStaffReviewApiGetAnswerData, ThrowOnError>) => (options.client ?? client).get<AppsProductTrackLabelingLabelQualityStaffReviewApiGetAnswerResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/product-track-labeling/label-quality/answers/{original_task_id}',
    ...options
});

/**
 * List Verification Tasks
 */
export const appsVerificationTasksApiListVerificationTasks = <ThrowOnError extends boolean = false>(options?: Options<AppsVerificationTasksApiListVerificationTasksData, ThrowOnError>) => (options?.client ?? client).get<AppsVerificationTasksApiListVerificationTasksResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/verification-tasks/',
    ...options
});

/**
 * Get Signed Urls
 */
export const appsVerificationTasksApiGetSignedUrls = <ThrowOnError extends boolean = false>(options: Options<AppsVerificationTasksApiGetSignedUrlsData, ThrowOnError>) => (options.client ?? client).post<AppsVerificationTasksApiGetSignedUrlsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/verification-tasks/signed-urls',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Batch Claim
 */
export const appsVerificationTasksApiBatchClaim = <ThrowOnError extends boolean = false>(options: Options<AppsVerificationTasksApiBatchClaimData, ThrowOnError>) => (options.client ?? client).post<AppsVerificationTasksApiBatchClaimResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/verification-tasks/batch-claim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Next Task
 *
 * Returns the next task for a given (task_type, user_id) combination.
 *
 * If there is a task already IN_REVIEW, return that one. Otherwise claim and return the oldest PENDING task.
 * Assumes a user can only have a single task of a given type IN_REVIEW at any time.
 */
export const appsVerificationTasksApiNextTask = <ThrowOnError extends boolean = false>(options: Options<AppsVerificationTasksApiNextTaskData, ThrowOnError>) => (options.client ?? client).post<AppsVerificationTasksApiNextTaskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/verification-tasks/next',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Verification Task
 */
export const appsVerificationTasksApiGetVerificationTask = <ThrowOnError extends boolean = false>(options: Options<AppsVerificationTasksApiGetVerificationTaskData, ThrowOnError>) => (options.client ?? client).get<AppsVerificationTasksApiGetVerificationTaskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/verification-tasks/{task_id}',
    ...options
});

/**
 * Claim Verification Task
 */
export const appsVerificationTasksApiClaimVerificationTask = <ThrowOnError extends boolean = false>(options: Options<AppsVerificationTasksApiClaimVerificationTaskData, ThrowOnError>) => (options.client ?? client).post<AppsVerificationTasksApiClaimVerificationTaskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/verification-tasks/{task_id}/claim',
    ...options
});

/**
 * Release Verification Task
 */
export const appsVerificationTasksApiReleaseVerificationTask = <ThrowOnError extends boolean = false>(options: Options<AppsVerificationTasksApiReleaseVerificationTaskData, ThrowOnError>) => (options.client ?? client).post<AppsVerificationTasksApiReleaseVerificationTaskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/verification-tasks/{task_id}/release',
    ...options
});

/**
 * Submit Verification Task
 */
export const appsVerificationTasksApiSubmitVerificationTask = <ThrowOnError extends boolean = false>(options: Options<AppsVerificationTasksApiSubmitVerificationTaskData, ThrowOnError>) => (options.client ?? client).post<AppsVerificationTasksApiSubmitVerificationTaskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v0/verification-tasks/{task_id}/submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
